
import React, { useEffect, useState, useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth, db, messaging } from './firebase';
import { signInWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth';
import { getToken, onMessage } from 'firebase/messaging';
import { useRuolo } from './useRuolo';
import { generaAlertAISala } from "./ai/aiSalaEngine";
import {
  collection, getDocs, doc, getDoc, onSnapshot,
  addDoc, setDoc, serverTimestamp, updateDoc, deleteDoc,
  query, where
} from 'firebase/firestore';
import './Dashboard.css';
import './navbar-spacing.css';
import './DashboardCameriereMenu.css';


const raggruppaPiatti = (items) => {
  const grouped = {};

  items.forEach((item) => {
    const nome = item.nome || item.name || "";
    const custom = (item.custom || "").trim();
    if (!nome) return;

    const key = `${nome}__${custom}`;

    if (!grouped[key]) {
      grouped[key] = {
        nome,
        custom,
        qty: 0
      };
    }

    grouped[key].qty += 1;
  });

  return Object.values(grouped);
};

const VAPID = "BGXeRvoaFDE71HURnhhKP6jQMaDXApYvdOnnvKUbl1_FVFKmK2Y4-CIg3O1m3rQqMuHsedHfn8WrigHpD-Mst0I";

function DashboardCameriere({ localeTag: propLocale, cameriereId: propCameriere }) {
  const [user] = useAuthState(auth);
  const { loading } = useRuolo(user?.uid);
  const params = useParams();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(window.location.search);

  let localeTag =
    propLocale || params.localeTag ||
    searchParams.get("locale") || localStorage.getItem("waiter_locale");

  let cameriereId =
    propCameriere || params.cameriereId ||
    searchParams.get("cameriere") || localStorage.getItem("waiter_id");

  if (localeTag && cameriereId) {
    localStorage.setItem("waiter_locale", localeTag);
    localStorage.setItem("waiter_id", cameriereId);
  }

  // AUTH
  const [authReady, setAuthReady] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setCurrentUser(u);
      setAuthReady(true);
    });
    return () => unsub();
  }, []);

  // STATE
  const [infoLocale, setInfoLocale] = useState({});
  const [localeBloccato, setLocaleBloccato] = useState(false);
  const [nomeCameriere, setNomeCameriere] = useState('');
  const [tavoliVisibili, setTavoliVisibili] = useState([]);
  const [tavoloSelezionato, setTavoloSelezionato] = useState(null);
  const [ordiniTavolo, setOrdiniTavolo] = useState([]);
  const [menu, setMenu] = useState([]);
  const [categorie, setCategorie] = useState([]);
  const [categoriaSelezionata, setCategoriaSelezionata] = useState('');
  const [carrello, setCarrello] = useState([]);
  const [inputValori, setInputValori] = useState({});
  const [messaggio, setMessaggio] = useState('');
  const [mostraMenu, setMostraMenu] = useState(false);
  const [mostraOrdini, setMostraOrdini] = useState(false);
  const [ordineInModifica, setOrdineInModifica] = useState(null);
  const [showRiepilogo, setShowRiepilogo] = useState(false);
  const [numeroCoperti, setNumeroCoperti] = useState(0);
  const [erroreCopertMancanti, setErroreCopertMancanti] = useState(false);
  const [showSetupComplete, setShowSetupComplete] = useState(false);

  // NOTIFICHE PRONTI
  const [prontiPerOrdine, setProntiPerOrdine] = useState({});
  const [badgeProntiPerTavolo, setBadgeProntiPerTavolo] = useState({});
  const [ordineProtiAperto, setOrdineProtiAperto] = useState(null);
  const notifiedItemsRef = useRef(new Set());

  // CHIAMATE SERVIZIO
  const [chiamateServizio, setChiamateServizio] = useState([]);
  const prevChiamateCount = useRef(0);

  // CATEGORIA NOTIFICA
  const [categoriaNotifica, setCategoriaNotifica] = useState(null);
  const [ordiniCategoriaNotifica, setOrdiniCategoriaNotifica] = useState([]);
  const [dettagliOrdineAperto, setDettagliOrdineAperto] = useState(null);
  const [alertAISelezionato, setAlertAISelezionato] = useState(null);
const [alertAIGestiti, setAlertAIGestiti] = useState([]);

const normalizzaAlertTipo = (alert) => {
  const testo = String(alert?.testo || alert?.text || "").toLowerCase();

  if (alert?.tipo) return alert.tipo;
  if (alert?.type) return alert.type;

  if (testo.includes("inattivo")) return "tavoloInattivo";
  if (testo.includes("servito")) return "tavoloServitoDa";
  if (testo.includes("chiama") || testo.includes("chiamata")) return "chiamataIgnorata";
  if (testo.includes("pronto")) return "prontoNonServito";
  if (testo.includes("cucina")) return "cucinaLenta";

  return "generico";
};

const getAlertAIKey = (tavolo, alert) => {
  const tipo = normalizzaAlertTipo(alert);

const sessione =
  tavolo?.token ||
  tavolo?.tokenSessione ||
  tavolo?.tokenAttuale ||
  tavolo?.sessionId ||
  tavolo?.clienteId ||
  tavolo?.creatoIl?.seconds ||
  "sessione";

  return `${localeTag}_${tavolo?.numero}_${tipo}_${sessione}`;
};

const filtraAlertAIGestiti = (tavolo, alerts = []) =>
  alerts.filter(alert => !alertAIGestiti.includes(getAlertAIKey(tavolo, alert)));

const segnaAlertGestito = async (tavolo) => {
  try {
    if (!localeTag || !tavolo?.numero) return;

    await Promise.all(
      (tavolo.alertAI || []).map((alert) => {
        const key = getAlertAIKey(tavolo, alert);

        return setDoc(
          doc(db, "ai_alert_gestiti", key),
          {
            key,
            locale: localeTag,
            tavolo: String(tavolo.numero),
            tipo: normalizzaAlertTipo(alert),
            testo: alert?.testo || alert?.text || "",
            gestito: true,
            gestitoAt: serverTimestamp()
          },
          { merge: true }
        );
      })
    );

    setAlertAISelezionato(null);
  } catch (err) {
    console.error("Errore salvataggio alert gestito:", err);
  }
};

useEffect(() => {
  if (!localeTag) return;

  const unsub = onSnapshot(collection(db, "ai_alert_gestiti"), (snap) => {
    const keys = snap.docs
      .map(d => d.data())
      .filter(a => a.locale === localeTag && a.gestito === true)
      .map(a => a.key);

    setAlertAIGestiti(prev => {
  const prevString = [...prev].sort().join("|");
  const nextString = [...keys].sort().join("|");

  if (prevString === nextString) {
    return prev;
  }

  return keys;
});
  });

  return () => unsub();
}, [localeTag]);

  // PUSH / UI
  const [showPushPopup, setShowPushPopup] = useState(false);
  const [notificationsEnabled, setNotificationsEnabled] = useState(false);
  const [pushAbilitato, setPushAbilitato] = useState(
    () => localStorage.getItem("waiter_push_paused") !== "true"
  );
  const [isStandby, setIsStandby] = useState(
    () => localStorage.getItem("waiter_push_paused") === "true"
  );
  const [showUserMenu, setShowUserMenu] = useState(false);
const [showInstallBanner, setShowInstallBanner] = useState(false);



useEffect(() => {
  if (!("Notification" in window)) return;
  if (!localeTag || !cameriereId) return;

  const savedToken = localStorage.getItem("waiter_push_token");
  const isPaused = localStorage.getItem("waiter_push_paused") === "true";

  if (
    Notification.permission !== "granted" &&
    !savedToken &&
    !isPaused
  ) {
    setShowPushPopup(true);
  }
}, [localeTag, cameriereId]);

const [aiSalaInsights, setAiSalaInsights] = useState([]);
const [ordiniRealtime, setOrdiniRealtime] = useState([]);
const isDemo = infoLocale?.demo === true;

const tornaAllaDashboardDemo = () => {
  navigate(`/dashboard-gestore?locale=${localeTag}`);
};

/* =========================================
   🤖 AI SALA ENGINE
========================================= */

useEffect(() => {



  if (!tavoliVisibili?.length) {
    setAiSalaInsights([]);
    return;
  }

  const insights = [];

  // Tavoli occupati
  const tavoliOccupati = tavoliVisibili.filter(t => t.impegnato);
// Tavoli occupati da molto tempo
let tavoliLenti = 0;

Object.values(prontiPerOrdine || {}).forEach((p) => {

  const ordine = p.ordine;

  if (!ordine?.timestamp?.seconds) return;

  const createdAt = ordine.timestamp.seconds * 1000;

  const minutiPassati = Math.floor(
    (Date.now() - createdAt) / 1000 / 60
  );

  // Tavolo attivo da oltre 45 minuti
  if (minutiPassati >= 45) {
    tavoliLenti++;
  }

});

  // Tavoli con piatti pronti
// Tavoli con piatti pronti
const tavoliConPronti = Object.values(prontiPerOrdine || {});
const numeroTavoliPronti = tavoliConPronti.length;

// Timer pronti
let tavoliInAttesaCritica = 0;

tavoliConPronti.forEach((p) => {

  const ordine = p.ordine;

  if (!ordine?.timestamp?.seconds) return;

  const createdAt = ordine.timestamp.seconds * 1000;

  const minutiPassati = Math.floor(
    (Date.now() - createdAt) / 1000 / 60
  );

  if (minutiPassati >= 5) {
    tavoliInAttesaCritica++;
  }

});
  // Chiamate servizio
  const numeroChiamate = chiamateServizio.length;

// PRIORITÀ OPERATIVA TAVOLI

let tavoloPrioritario = null;
let scorePriorita = 0;

tavoliConPronti.forEach((p) => {

  const tavolo = p.tavolo;
  const totalePiatti = p.items?.length || 0;

  const ordine = p.ordine;

  let minutiPassati = 0;

  if (ordine?.timestamp?.seconds) {

    const createdAt =
      ordine.timestamp.seconds * 1000;

    minutiPassati = Math.floor(
      (Date.now() - createdAt) / 1000 / 60
    );
  }

  // score AI
  let score = 0;

  // attesa lunga
  score += minutiPassati * 10;

  // molti piatti
  score += totalePiatti * 5;

  // chiamata servizio
  const haChiamata = chiamateServizio.some(
    c => String(c.tavolo) === String(tavolo)
  );

  if (haChiamata) {
    score += 100;
  }

  if (score > scorePriorita) {
    scorePriorita = score;
    tavoloPrioritario = tavolo;
  }

});

// ALERT PIATTI PRONTI CONTESTUALI

tavoliConPronti.forEach((p) => {

  const tavolo = p.tavolo;
  const totalePiatti = p.items?.length || 0;

  const ordine = p.ordine;

  let minutiPassati = 0;

  if (ordine?.timestamp?.seconds) {

    const createdAt =
      ordine.timestamp.seconds * 1000;

    minutiPassati = Math.floor(
      (Date.now() - createdAt) / 1000 / 60
    );
  }

  // Mostra solo se il ritardo è realmente critico
  if (minutiPassati >= 5) {

    insights.push({
      type: "pronti",
      priority: "alta",
      text:
        totalePiatti > 1
          ? `Tavolo ${tavolo} ha ${totalePiatti} piatti pronti da ${minutiPassati} minuti`
          : `Tavolo ${tavolo} ha un piatto pronto da ${minutiPassati} minuti`
    });

  }

});

// PRIORITÀ SERVIZIO DISABILITATA
// L'informazione è già contenuta negli alert
// dei piatti pronti e quindi evitiamo duplicazioni.

  // ALERT CHIAMATE SERVIZIO IGNORATE

const minutiChiamataIgnorata =
  Number(
    infoLocale?.aiSalaConfig
      ?.supervisoreSala
      ?.chiamataIgnorata
      ?.minuti
  ) || 5;

chiamateServizio.forEach((chiamata) => {
  const tavolo = chiamata.tavolo || chiamata.table || "?";

  const createdAt =
    chiamata.timestamp?.seconds
      ? chiamata.timestamp.seconds * 1000
      : chiamata.createdAt?.seconds
        ? chiamata.createdAt.seconds * 1000
        : chiamata.data?.seconds
          ? chiamata.data.seconds * 1000
          : null;

  if (!createdAt) return;

  const minutiPassati = Math.floor(
    (Date.now() - createdAt) / 1000 / 60
  );

  if (minutiPassati >= minutiChiamataIgnorata) {
    insights.push({
      type: "chiamata_ignorata",
      priority: "alta",
      text: `Tavolo ${tavolo} chiama da ${minutiPassati} minuti`
    });
  }
});



// TAVOLI FERMI
if (tavoliLenti > 0) {

  insights.push({
    type: "latenza",
    priority: "media",
    text: `${tavoliLenti} tavolo occupati da oltre 45 minuti`
  });

}


// AI PERCORSO OTTIMIZZATO

const tavoliProntiNumerici = tavoliConPronti
  .map(p => String(p.tavolo))
  .filter(t => /^\d+$/.test(t))
  .map(Number)
  .sort((a, b) => a - b);

for (let i = 0; i < tavoliProntiNumerici.length - 1; i++) {

  const corrente = tavoliProntiNumerici[i];
  const successivo = tavoliProntiNumerici[i + 1];

  // tavoli vicini
  if (Math.abs(corrente - successivo) === 1) {

    insights.push({
      type: "percorso",
      priority: "media",
      text: `Conviene servire Tavolo ${corrente} e ${successivo} insieme`
    });

  }

}

// PREVISIONE STRESS SALA

let tavoliRecenti = 0;

Object.values(prontiPerOrdine || {}).forEach((p) => {

  const ordine = p.ordine;

  if (!ordine?.timestamp?.seconds) return;

  const createdAt =
    ordine.timestamp.seconds * 1000;

  const minutiPassati = Math.floor(
    (Date.now() - createdAt) / 1000 / 60
  );

  // ordini negli ultimi 20 minuti
  if (minutiPassati <= 20) {
    tavoliRecenti++;
  }

});

// tanti tavoli attivi recentemente
if (
  tavoliRecenti >= 5 &&
  numeroTavoliPronti >= 3
) {

  insights.push({
    type: "stress",
    priority: "alta",
    text: "La sala potrebbe saturarsi nei prossimi minuti"
  });

}

  // SALA PIENA
  if (tavoliOccupati.length >= 8) {
    insights.push({
      type: "full",
      priority: "media",
      text: `Sala molto attiva (${tavoliOccupati.length} tavoli occupati)`
    });
  }

 const PRIORITA_AI = {
  chiamata_ignorata: 110,
  servizio: 100,
  stress: 95,
  ritardo: 90,
  priorita: 85,
  pronti: 70,
  latenza: 50,
  percorso: 40,
  upselling: 35,
  full: 30
};

const insightsOrdinati = insights.sort((a, b) => {
  return (
    (PRIORITA_AI[b.type] || 0) -
    (PRIORITA_AI[a.type] || 0)
  );
});

setAiSalaInsights(insightsOrdinati);

}, [
  tavoliVisibili,
  prontiPerOrdine,
  chiamateServizio,
  ordiniRealtime
]);

  // Orologio standby
  const [oraNow, setOraNow] = useState(new Date());
  useEffect(() => {
    if (!isStandby) return;
    const id = setInterval(() => setOraNow(new Date()), 10000);
    return () => clearInterval(id);
  }, [isStandby]);

  // REFS
  const audioRef = useRef(null);
  const userMenuRef = useRef(null);
const aiMemoryRef = useRef({});

  useEffect(() => {
    if (ordineInModifica) setNumeroCoperti(ordineInModifica.coperti || 0);
  }, [ordineInModifica]);

  // CLICK OUTSIDE HAMBURGER
  useEffect(() => {
    const h = (e) => { if (userMenuRef.current && !userMenuRef.current.contains(e.target)) setShowUserMenu(false); };
    if (showUserMenu) document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, [showUserMenu]);

  // INSTALL BANNER
  useEffect(() => {
    const h = (e) => { e.preventDefault(); window.__WAITerInstallPrompt = e; };
    window.addEventListener("beforeinstallprompt", h);
    return () => window.removeEventListener("beforeinstallprompt", h);
  }, []);
  useEffect(() => {
    if (window.__WAITerInstallPrompt && !window.matchMedia('(display-mode: standalone)').matches && localStorage.getItem("waiter_install_dismissed") !== "true")
      setShowInstallBanner(true);
  }, []);

  // PUSH SETUP
  useEffect(() => {
    const setup = async () => {
      if (!messaging) return;

      const isPaused = localStorage.getItem("waiter_push_paused") === "true";

      const savedToken = localStorage.getItem("waiter_push_token");

      // 🔥 SE STANDBY → NON FARE NULLA
      if (isPaused) {
        console.log("⏸️ Standby attivo → blocco push");
        setNotificationsEnabled(false);
        return; // ✅ STOP CORRETTO
      }

      // 🔥 CREA TOKEN SE NON ESISTE
      if (Notification.permission === "granted" && !savedToken && cameriereId && localeTag) {
        try {
          const reg = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
          await navigator.serviceWorker.ready;

          const token = await getToken(messaging, {
            vapidKey: VAPID,
            serviceWorkerRegistration: reg
          });

          if (!token) return;

          localStorage.setItem("waiter_push_token", token);

          await setDoc(doc(db, "pushTokens", token), {
            cameriereId,
            locale: localeTag,
            ruolo: "cameriere",
            token,
            createdAt: serverTimestamp(),
            userAgent: navigator.userAgent
          });

          setNotificationsEnabled(true);

        } catch (e) {
          console.error(e);
        }
      }
    };
    setup();
  }, [cameriereId, localeTag]);

  const enableNotificationsManually = async () => {
    try {
      const permission = await Notification.requestPermission();
      if (permission !== "granted") { alert("Devi permettere le notifiche per continuare."); return; }
      const reg = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
      await navigator.serviceWorker.ready;
      const token = await getToken(messaging, { vapidKey: VAPID, serviceWorkerRegistration: reg });
      if (!token) return;
      localStorage.setItem("waiter_push_token", token);
      await setDoc(doc(db, "pushTokens", token), { cameriereId, locale: localeTag, ruolo: "cameriere", token, createdAt: serverTimestamp(), userAgent: navigator.userAgent });
      setNotificationsEnabled(true);
      setShowPushPopup(false);
      setShowSetupComplete(true);
      localStorage.setItem("waiter_setup_complete", "true");
    } catch (e) { console.error(e); }
  };

  // STANDBY COMPLETO — silenzia push + suono, mostra schermata di blocco
 const applicaStandby = async (
  nuovoStandby,
  aggiornaFirestore = false
) => {
  setIsStandby(nuovoStandby);
  setPushAbilitato(!nuovoStandby);

  if (nuovoStandby) {
    localStorage.setItem("waiter_push_paused", "true");
  } else {
    localStorage.removeItem("waiter_push_paused");
  }

  const token = localStorage.getItem("waiter_push_token");

  if (nuovoStandby) {
    if (token) {
      try {
        const q = query(
          collection(db, "pushTokens"),
          where("token", "==", token)
        );

        const snap = await getDocs(q);

        await Promise.all(
          snap.docs.map((d) => deleteDoc(d.ref))
        );

        localStorage.removeItem("waiter_push_token");
        setNotificationsEnabled(false);
      } catch (e) {
        console.error(e);
      }
    }
  } else {
    setOraNow(new Date());

    try {
      const reg = await navigator.serviceWorker.ready;

      const newToken = await getToken(messaging, {
        vapidKey: VAPID,
        serviceWorkerRegistration: reg
      });

      if (newToken) {
        localStorage.setItem("waiter_push_token", newToken);

        await setDoc(doc(db, "pushTokens", newToken), {
          cameriereId,
          locale: localeTag,
          ruolo: "cameriere",
          token: newToken,
          createdAt: serverTimestamp(),
          userAgent: navigator.userAgent
        });

        setNotificationsEnabled(true);
      }
    } catch (e) {
      console.error(e);
    }
  }

  if (aggiornaFirestore && cameriereId) {
    try {
      await setDoc(
        doc(db, "camerieri", cameriereId),
        {
          statoOperativo: nuovoStandby
            ? "standby"
            : "attivo",
          ultimoAggiornamentoStato: serverTimestamp()
        },
        { merge: true }
      );
    } catch (error) {
      console.error(
        "Errore aggiornamento stato cameriere:",
        error
      );
    }
  }

  setShowUserMenu(false);
};

const toggleStandby = () => {
  applicaStandby(!isStandby, true);
};

useEffect(() => {
  if (!cameriereId) return;

  const unsubscribe = onSnapshot(
    doc(db, "camerieri", cameriereId),
    (snap) => {
      if (!snap.exists()) return;

      const statoRemoto = snap.data().statoOperativo;

      if (
        statoRemoto !== "standby" &&
        statoRemoto !== "attivo"
      ) {
        return;
      }

      const nuovoStandby = statoRemoto === "standby";

      const standbyLocale =
        localStorage.getItem("waiter_push_paused") === "true";

      if (nuovoStandby !== standbyLocale) {
        applicaStandby(nuovoStandby, false);
      }
    },
    (error) => {
      console.error(
        "Errore ascolto stato cameriere:",
        error
      );
    }
  );

  return () => unsubscribe();
}, [cameriereId])

  const resetBadge = async () => {
    if ("serviceWorker" in navigator) {
      const reg = await navigator.serviceWorker.ready;
      const sw = reg.active || navigator.serviceWorker.controller;
      sw?.postMessage({ type: "RESET_BADGE" });
    }
  };
  useEffect(() => { resetBadge(); }, []);

  // 🔔 Foreground FCM: quando la PWA è aperta, FCM non mostra notifiche automaticamente.
  // Intercettiamo onMessage e usiamo il SW per mostrarla ugualmente,
  // così il comportamento è identico a PWA chiusa (una sola push cumulativa).
  useEffect(() => {
    if (!messaging) return;
    const unsub = onMessage(messaging, (payload) => {
  const type = payload.data?.type || "";

  const tipiConsentiti = [
    "GROUPED_READY",
    "SERVICE_CALL",
    "CATEGORY_ORDER"
  ];

  if (!tipiConsentiti.includes(type)) return;

      const title = payload.data?.title || payload.notification?.title || "QrMenu";
      const body  = payload.data?.body  || payload.notification?.body  || "";

      // Suono già gestito dall'onSnapshot — non lo ripetiamo

      // Mostriamo la notifica tramite SW registration per coerenza visiva
      navigator.serviceWorker.ready.then(reg => {
        reg.showNotification(title, {
          body,
          icon: "/icons/notification-icon.png",
          badge: "/icons/notification-badge.png",
          data: payload.data || {},
        });
      }).catch(() => {
        // Fallback: Notification API diretta se SW non disponibile
        if (Notification.permission === "granted") {
          new Notification(title, { body, icon: "/icons/notification-icon.png" });
        }
      });
    });
    return () => unsub();
  }, []);

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem("waiter_push_token");
      if (token) {
        const q = query(collection(db, "pushTokens"), where("token", "==", token));
        const snap = await getDocs(q);
        await Promise.all(snap.docs.map(d => deleteDoc(d.ref)));
        localStorage.removeItem("waiter_push_token");
      }
    } catch (e) { console.error(e); }
    localStorage.removeItem("waiter_locale");
    localStorage.removeItem("waiter_id");
    localStorage.setItem("waiter_setup_complete", "true");
    window.location.reload();
  };

  // AUTO-LOGIN
  useEffect(() => {
    const autoLogin = async () => {
      if (!cameriereId || user) return;
      await new Promise(r => setTimeout(r, 500));
      if (auth.currentUser) return;
      try {
        const snap = await getDoc(doc(db, 'camerieri', cameriereId));
        if (!snap.exists()) { setMessaggio('❌ Cameriere non trovato'); return; }
        const d = snap.data();
        if (d.email && d.password) {
          await signInWithEmailAndPassword(auth, d.email, d.password);
          setMessaggio('✅ Login automatico completato');
          setTimeout(() => setMessaggio(''), 2000);
        }
      } catch (e) { setMessaggio(`❌ Errore login: ${e.code}`); setTimeout(() => setMessaggio(''), 5000); }
    };
    autoLogin();
  }, [cameriereId, user]);

  const gestisciChiamataServizio = async (id) => {
    try { await deleteDoc(doc(db, 'chiamateServizio', id)); } catch (e) { console.error(e); }
    await resetBadge();
  };

  const isAsportoOrder = (o) => {
    const table = String(o.table || o.tavolo || "").toUpperCase();
    const chiave = String(o.chiaveTavolo || "").toUpperCase();
    const tipo = String(o.tipoOrdine || "").toUpperCase();

    return (
      tipo === "ASPORTO" ||
      table.includes("ASPORTO") ||
      chiave.includes("ASPORTO")
    );
  };

  // FETCH LOCALE + BLOCCO
  useEffect(() => {
    if (!localeTag) return;

    const ref = doc(db, 'locali', localeTag);

    const unsub = onSnapshot(ref, (snap) => {
      if (!snap.exists()) return;

      const data = snap.data();

      setInfoLocale(data);

      if (data.stato === "bloccato") {
        setLocaleBloccato(true);
      } else {
        setLocaleBloccato(false);
      }
    });

    return () => unsub();
  }, [localeTag]);

  // FETCH CAMERIERE
  useEffect(() => {
    if (!cameriereId) return;
    getDoc(doc(db, "camerieri", cameriereId)).then(s => {
      if (!s.exists()) return;
      const d = s.data();
      setNomeCameriere(d.nome || d.username || 'Cameriere');
      let cats = [];
      if (d.categorieNotifica?.length > 0) cats = d.categorieNotifica;
      else if (d.categoriaNotifica) cats = [d.categoriaNotifica];
      setCategoriaNotifica(cats.length > 0 ? cats : null);
    });
  }, [cameriereId]);

  /* =========================================
   📦 ORDINI REALTIME GLOBALI
========================================= */

useEffect(() => {

  if (!localeTag) return;

  const q = query(
    collection(db, "ordini"),
    where("locale", "==", localeTag)
  );

  const unsub = onSnapshot(q, (snap) => {

    const ordini = snap.docs.map((d) => ({
      id: d.id,
      ...d.data()
    }));

    setOrdiniRealtime(ordini);

  });

  return () => unsub();

}, [localeTag]);

  // FETCH MENU
  useEffect(() => {
    if (!localeTag) return;
    const load = async () => {
      const ms = await getDocs(collection(db, 'menu'));
      const piatti = ms.docs.map(d => ({ id: d.id, ...d.data() })).filter(p => p.localeTag === localeTag && p.visibile !== false).sort((a, b) => (a.ordine || 0) - (b.ordine || 0));
      const cs = await getDocs(collection(db, 'categorie'));
      const cats = cs.docs.map(d => ({ id: d.id, ...d.data() })).filter(c => c.localeTag === localeTag && c.visibile !== false).sort((a, b) => (a.ordine || 0) - (b.ordine || 0));
      setMenu(piatti);
      setCategorie(cats);
      if (cats.length > 0) setCategoriaSelezionata(cats[0].nome);
    };
    load();
  }, [localeTag]);

  // LISTENER TAVOLI + AI SALA
  useEffect(() => {
    if (!localeTag) return;

    const numeroTavoli =
      infoLocale?.numeroTavoli || infoLocale?.tavoli || 0;

    const sale = infoLocale?.sale || [];

    if (numeroTavoli === 0 && sale.length === 0) return;

    const ATTIVAZIONE_TIMEOUT_MINUTI = 120;

    let attivazioniCache = [];
    let ordiniCache = [];

    const aggiornaTavoli = () => {
      const ordini = ordiniCache.filter(o =>
        o.locale === localeTag &&
        o.stato !== "pagamento" &&
        o.stato !== "archiviato" &&
        !isAsportoOrder(o)
      );

      const costruisciTavolo = (numero, sala) => {
        const attivoRaw = attivazioniCache.find((a) => {
          const parts = a.id.split("_");
          const localeDoc = parts[0];
          const tavoloDoc = parts[1];

          return (
            localeDoc === localeTag &&
            String(tavoloDoc).toUpperCase() ===
            String(numero).toUpperCase()
          );
        });

        const ultimoPing =
          attivoRaw?.ultimoPing?.seconds
            ? attivoRaw.ultimoPing.seconds * 1000
            : null;

        const attivoRecente =
          ultimoPing &&
          Date.now() - ultimoPing <
            ATTIVAZIONE_TIMEOUT_MINUTI * 60 * 1000;

        const attivo = attivoRecente ? attivoRaw : null;

        const ord = ordini.filter(o =>
          String(o.table).toUpperCase() === String(numero).toUpperCase() ||
          String(o.tavolo).toUpperCase() === String(numero).toUpperCase()
        );

        const impegnato = ord.length > 0;

        return {
          id: `${localeTag}_${numero}`,
          numero,
          sala,
          attivo: !!attivo,
          clientePresente: !!attivo && !impegnato,
          impegnato,
          totaleOrdini: ord.reduce((s, o) => s + (o.totale || 0), 0),

alertAI: filtraAlertAIGestiti(
  {
    numero,
    ...attivo
  },
  generaAlertAISala({
    tavolo: {
      numero,
      impegnato,
      attivo: !!attivo,
      ...attivo
    },
    aiSalaConfig: infoLocale?.aiSalaConfig,
    ordini: ord,
    chiamateServizio
  })
),

          ...attivo
        };
      };

      const tavoli = [];

      for (let i = 0; i < numeroTavoli; i++) {
        const n = (i + 1).toString();
        tavoli.push(costruisciTavolo(n, "principale"));
      }

      sale.forEach((sala) => {
        for (let i = 1; i <= sala.numeroTavoli; i++) {
          const n = `${sala.lettera}${i}`;
          tavoli.push(costruisciTavolo(n, sala.lettera));
        }
      });

      setTavoliVisibili(tavoli);
    };

    const unsubOrdini = onSnapshot(collection(db, "ordini"), (snap) => {
      ordiniCache = snap.docs.map(d => ({
        id: d.id,
        ...d.data()
      }));

      aggiornaTavoli();
    });

    const unsubAttivazioni = onSnapshot(
      collection(db, "attivazioniSessioni"),
      (snap) => {
        attivazioniCache = snap.docs
          .map(d => ({
            id: d.id,
            ...d.data()
          }))
          .filter(a => a.id.split("_")[0] === localeTag);

        aggiornaTavoli();
      }
    );

    const interval = setInterval(() => {
      aggiornaTavoli();
    }, 30000);

    return () => {
      unsubOrdini();
      unsubAttivazioni();
      clearInterval(interval);
    };
 }, [localeTag, infoLocale, chiamateServizio, alertAIGestiti]);

  // LISTENER CHIAMATE SERVIZIO
  useEffect(() => {
    if (!localeTag || !authReady) return;
    const q = query(collection(db, "chiamateServizio"), where("locale", "==", localeTag), where("gestita", "==", false));
    const unsub = onSnapshot(q, (snap) => {
      const chiamate = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      if (chiamate.length > prevChiamateCount.current && !isStandby) audioRef.current?.play().catch(() => {});
      prevChiamateCount.current = chiamate.length;
      setChiamateServizio(chiamate);
    });
    return () => unsub();
  }, [localeTag, authReady, currentUser, isStandby]);

  // LISTENER ORDINI PRONTI — per-item, real-time, si aggiorna e si svuota automaticamente
  useEffect(() => {
    if (!localeTag || !cameriereId) return;
    const unsub = onSnapshot(
      query(collection(db, "ordini"), where("locale", "==", localeTag)),
      (snapshot) => {
        const nuovoPronti = {};
        const nuovoBadge = {};
        const keysAttuali = new Set();
        const nuoveKeys = new Set();

        snapshot.docs.forEach(docSnap => {
          const ordine = { id: docSnap.id, ...docSnap.data() };

          // 🚫 BLOCCA ASPORTO QUI
          if (isAsportoOrder(ordine)) return;
          const tavoloNumero = ordine.table || ordine.tavolo;
          const itemsPronti = [];

          (ordine.items || []).forEach((item, idx) => {
            const stato = String(
              item.stato ||
              ordine.itemStati?.[String(idx)] ||
              ""
            ).toLowerCase();
            if (stato === "pronto") {
              const key = `${ordine.id}_${idx}`;
              keysAttuali.add(key);

              if (!notifiedItemsRef.current.has(key)) {
                nuoveKeys.add(key);
              }

              itemsPronti.push({
                idx,
                nome: item.nome || item.name,
                custom: item.custom || "",
                key
              });
              nuovoBadge[tavoloNumero] = (nuovoBadge[tavoloNumero] || 0) + 1;
            }
          });

          if (itemsPronti.length > 0) {
            nuovoPronti[ordine.id] = { tavolo: tavoloNumero, items: itemsPronti, ordine };
          }
        });


        if (nuoveKeys.size > 0 && !isStandby) {
          // 🔔 Suono in-app quando la PWA è aperta
          audioRef.current?.play().catch(() => {});
          // Le notifiche visive sono gestite esclusivamente dalla push FCM
          // (notifyReadyCallable → firebase-messaging-sw.js → onBackgroundMessage).
          // Non usiamo new Notification() qui per evitare duplicati.
        }

        // mantiene memoria dei piatti attualmente pronti
        notifiedItemsRef.current = keysAttuali;

        setProntiPerOrdine(nuovoPronti);
        setBadgeProntiPerTavolo(nuovoBadge);

        // aggiorna il modale se è aperto e l'ordine è cambiato
        setOrdineProtiAperto(prev => {
          if (!prev) return prev;

          const tavolo = prev.tavolo;

          const aggiornato = Object.values(nuovoPronti).filter(p => p.tavolo === tavolo);

          if (aggiornato.length === 0) return null;

          const items = aggiornato.flatMap(p => p.items);
          const ordini = aggiornato.map(p => p.ordine);

          return {
            ...prev,
            items,
            ordini
          };
        });
      }
    );
    return () => unsub();
  }, [localeTag, cameriereId, isStandby]);

  // LISTENER CATEGORIA NOTIFICA
  // Mostra ordini con almeno un item della categoria NON ancora servito
  // Solo stato "inviato" — se la cucina ha già preso in carico non mostrare la card
  useEffect(() => {
    if (!localeTag || !categoriaNotifica || !cameriereId) { setOrdiniCategoriaNotifica([]); return; }
    const q = query(collection(db, 'ordini'), where('locale', '==', localeTag));
    const unsub = onSnapshot(q, (snap) => {
      const tuttiOrdini = snap.docs.map(d => ({ id: d.id, ...d.data() }));

      const ordini = tuttiOrdini.filter(o => {
        if (o.stato === 'pagamento' || o.stato === 'archiviato') return false;
        if (isAsportoOrder(o)) return false;
        return (o.items || []).some((item) => {
          // ✅ Mostra solo se lo stato dell'item è "inviato" o non ancora processato
          const statoItem = String(item.stato || "").toLowerCase();
          if (statoItem === "servito") return false;
          const catDiretta = item.categoria || item.category || "";
          if (catDiretta && categoriaNotifica.includes(catDiretta)) return true;
          const nomePiatto = item.name || item.nome || "";
          const piatto = menu.find(p => p.nome === nomePiatto || p.name === nomePiatto);
          return piatto?.categoria && categoriaNotifica.includes(piatto.categoria);
        });
      });

      setOrdiniCategoriaNotifica(ordini);

      // Aggiorna dettagliOrdineAperto in tempo reale se è aperto
      setDettagliOrdineAperto(prev => {
        if (!prev) return prev;
        const aggiornato = tuttiOrdini.find(o => o.id === prev.id);
        if (!aggiornato) return null; // ordine eliminato
        // Controlla se ha ancora item della categoria in stato "inviato"
        const haItemDaServire = (aggiornato.items || []).some((item) => {
          const statoItem = String(item.stato || "").toLowerCase();
          if (statoItem === "servito") return false;
          const catDiretta = item.categoria || item.category || "";
          if (catDiretta && categoriaNotifica.includes(catDiretta)) return true;
          const nomePiatto = item.name || item.nome || "";
          const piatto = menu.find(p => p.nome === nomePiatto || p.name === nomePiatto);
          return piatto?.categoria && categoriaNotifica.includes(piatto.categoria);
        });
        if (!haItemDaServire) return null; // tutti serviti: chiudi modale
        return aggiornato; // aggiorna con dati freschi
      });
    });
    return () => unsub();
  }, [localeTag, categoriaNotifica, menu, cameriereId]);

  // APRI MENU TAVOLO
  const apriMenuTavolo = async (tavolo) => {
    setTavoloSelezionato(tavolo);
    setCarrello([]);
    setMostraOrdini(false);
    setMostraMenu(false);
    if (tavolo.impegnato) {
      if (window._unsubscribeOrdiniTavolo) window._unsubscribeOrdiniTavolo();
      const q = query(collection(db, 'ordini'), where('locale', '==', localeTag), where('table', '==', tavolo.numero), where('stato', 'not-in', ['pagamento', 'archiviato']));
      window._unsubscribeOrdiniTavolo = onSnapshot(q, (s) => {
        setOrdiniTavolo(s.docs.map(d => ({ id: d.id, ...d.data() })).filter(o => String(o.table).toUpperCase() === String(tavolo.numero).toUpperCase()));
        setMostraOrdini(true);
      });
    } else {
      if (window._unsubscribeOrdiniTavolo) window._unsubscribeOrdiniTavolo();
      setOrdiniTavolo([]);
      setMostraMenu(true);
    }
  };

  const aggiungiAlCarrello = (piatto) => {
    const custom = (inputValori[piatto.id]?.custom || "").trim();

    setCarrello(prev => {
      const index = prev.findIndex(
        item =>
          item.id === piatto.id &&
          (item.custom || "") === (custom || "") &&
          item.stato === "inviato"
      );

      if (index !== -1) {
        // 🔥 aumenta quantità invece di duplicare
        const updated = [...prev];
        updated[index].quantita += 1;
        return updated;
      }

      // nuovo item
      return [
        ...prev,
        {
          ...piatto,
          nome: piatto.nome || piatto.name || "",
          name: piatto.nome || piatto.name || "",
          quantita: 1,
          quantity: 1,
          custom,
          stato: "inviato",
          uid: Date.now().toString() + "_" + Math.random().toString(36).slice(2)
        }
      ];
    });

    setInputValori(prev => ({
      ...prev,
      [piatto.id]: { quantita: 1, custom: "" }
    }));
  };

  const modificaQuantita = (piattoId, custom, nuovaQuantita) => {
    // Ora si usa solo uid per identificare l'item
    if (nuovaQuantita <= 0) setCarrello(carrello.filter(i => i.uid !== piattoId));
    else setCarrello(carrello.map(i =>
      i.uid === piattoId
        ? { ...i, quantita: nuovaQuantita, quantity: nuovaQuantita }
        : i
    ));
  };

  const rimuoviDalCarrello = (uid) => {
    setCarrello(carrello.filter(i => i.uid !== uid));
  };

  const inviaOrdine = async () => {
    // 🔥 BLOCCO LOCALE (OBBLIGATORIO)
    const localeRef = doc(db, "locali", localeTag);
    const localeSnap = await getDoc(localeRef);

    if (localeSnap.exists() && localeSnap.data().stato === "bloccato") {
      setMessaggio("🚫 Locale disattivato");
      setTimeout(() => setMessaggio(""), 3000);
      return false;
    }

    if (carrello.length === 0 || !tavoloSelezionato) return false;
    if (numeroCoperti === 0) { setMessaggio('❌ Seleziona il numero di coperti'); setTimeout(() => setMessaggio(''), 3000); setErroreCopertMancanti(true); return false; }
    setErroreCopertMancanti(false);
    try {
      const nuoviItems = carrello.map(i => ({
        nome: i.nome || i.name || "",
        name: i.nome || i.name || "",
        prezzo: i.prezzo,
        price: i.prezzo,
        quantita: i.quantita,
        quantity: i.quantita,
        categoria: i.categoria || "",
        custom: i.custom || "",
        stato: "inviato",   // ✅ nuovo piatto sempre inviato
        uid: i.uid || (Date.now().toString() + "_" + Math.random().toString(36).slice(2))
      }));

      if (ordiniTavolo.length > 0) {
        // ✅ Tavolo già occupato: merge nel primo documento preservando stati esistenti
        const primoOrdine = ordiniTavolo[0];
        const itemsEsistenti = primoOrdine.items || [];
        const itemStatiEsistenti = primoOrdine.itemStati || {};

        const itemsFinali = [...itemsEsistenti, ...nuoviItems];

        // Preserva itemStati esistenti, aggiungi "inviato" per i nuovi
        const itemStatiFinali = { ...itemStatiEsistenti };
        nuoviItems.forEach((_, i) => {
          itemStatiFinali[String(itemsEsistenti.length + i)] = "inviato";
        });

        // Stato globale = più urgente tra tutti
        const PRIORITA = ["inviato", "in attesa", "in preparazione", "pronto", "servito"];
        const statiTutti = itemsFinali.map((item, idx) =>
          item.stato || itemStatiFinali[String(idx)] || "inviato"
        );
        const nuovoStatoGlobale = PRIORITA.find(s => statiTutti.includes(s)) || "inviato";

        const totale = itemsFinali.reduce((s, i) => s + parseFloat(i.prezzo || i.price || 0) * (i.quantita || i.quantity || 1), 0);

        await updateDoc(doc(db, 'ordini', primoOrdine.id), {
          items: itemsFinali,
          piatti: itemsFinali,
          itemStati: itemStatiFinali,
          stato: nuovoStatoGlobale,
          totale,
          coperti: numeroCoperti || primoOrdine.coperti || 0,
          notificaCategoriaInviata: primoOrdine.notificaCategoriaInviata ?? false,

          // 🔥 QUESTA È LA CHIAVE
          vistoInCucina: false
        });

        // Elimina eventuali altri documenti duplicati
        const altriDocs = ordiniTavolo.slice(1);
        if (altriDocs.length > 0) {
          await Promise.all(altriDocs.map(o => deleteDoc(doc(db, 'ordini', o.id))));
        }
      } else {
        // Tavolo vuoto: crea nuovo documento
        const totale = nuoviItems.reduce((s, i) => s + parseFloat(i.prezzo) * i.quantita, 0);
        const itemStati = {};
        nuoviItems.forEach((_, i) => { itemStati[String(i)] = "inviato"; });

        await addDoc(collection(db, 'ordini'), {
          locale: localeTag,
          table: tavoloSelezionato.numero,
          tavolo: tavoloSelezionato.numero,
          chiaveTavolo: `${localeTag}___${tavoloSelezionato.numero}`,
          token: "dashboard-cameriere-demo",
          piatti: nuoviItems,
          items: nuoviItems,
          itemStati,
          totale,
          stato: 'inviato',
          timestamp: serverTimestamp(),
          preso_da: 'cameriere',
          cameriere_id: cameriereId || "DEMO_CAMERIERE",
          coperti: numeroCoperti,
          vistoInCucina: false
        });
      }

      setMessaggio(`✅ Ordine inviato per tavolo ${tavoloSelezionato.numero}`);
      setTimeout(() => setMessaggio(''), 3000);
      setMostraMenu(false); setMostraOrdini(false); setCarrello([]); setTavoloSelezionato(null); setNumeroCoperti(0);
      return true;
    } catch (e) { console.error(e); setMessaggio('❌ Errore invio ordine'); setTimeout(() => setMessaggio(''), 3000); return false; }
  };

  const eliminaOrdine = async () => {
    const localeRef = doc(db, "locali", localeTag);
    const localeSnap = await getDoc(localeRef);

    if (localeSnap.exists() && localeSnap.data().stato === "bloccato") {
      setMessaggio("🚫 Locale disattivato");
      return;
    }
    if (!window.confirm('Vuoi davvero eliminare questo ordine?')) return;
    try {
      if (!auth.currentUser) { setMessaggio('❌ Devi essere autenticato'); setTimeout(() => setMessaggio(''), 3000); return; }
      const q = query(collection(db, 'ordini'), where('locale', '==', localeTag), where('table', '==', tavoloSelezionato.numero));
      const snap = await getDocs(q);
      await Promise.all(snap.docs.map(d => deleteDoc(d.ref)));
      setMessaggio('✅ Ordine eliminato'); setTimeout(() => setMessaggio(''), 3000);
      setOrdiniTavolo([]); setMostraOrdini(false);
    } catch (e) {
      setMessaggio(e.code === 'permission-denied' ? '❌ Permessi insufficienti' : `❌ Errore: ${e.code}`);
      setTimeout(() => setMessaggio(''), 5000);
    }
  };

  const salvaModificaOrdine = async () => {
    const localeRef = doc(db, "locali", localeTag);
    const localeSnap = await getDoc(localeRef);

    if (localeSnap.exists() && localeSnap.data().stato === "bloccato") {
      setMessaggio("🚫 Locale disattivato");
      return;
    }
    if (!ordineInModifica || ordineInModifica.items.length === 0) {
      setMessaggio('❌ Ordine vuoto');
      setTimeout(() => setMessaggio(''), 3000);
      return;
    }

    try {
      const items = ordineInModifica.items.map((i) => ({
        ...i,
        nome: i.nome || i.name || "",
        name: i.nome || i.name || "",
        prezzo: i.prezzo || i.price || 0,
        price: i.prezzo || i.price || 0,
        quantita: i.quantita || i.quantity || 1,
        quantity: i.quantita || i.quantity || 1,
        custom: i.custom || "",
        categoria: i.categoria || "",
        stato: i.stato || "inviato",
        uid: i.uid || (Date.now().toString() + "_" + Math.random().toString(36).slice(2))
      }));

      const itemStati = {};
      items.forEach((item, idx) => {
        itemStati[String(idx)] = item.stato || "inviato";
      });

      const PRIORITA = ["inviato", "in attesa", "in preparazione", "pronto", "servito"];
      const statiTutti = items.map(i => i.stato || "inviato");
      const nuovoStatoGlobale = PRIORITA.find(s => statiTutti.includes(s)) || "inviato";

      const totale = items.reduce(
        (s, i) => s + parseFloat(i.prezzo || i.price || 0) * parseInt(i.quantita || i.quantity || 1, 10),
        0
      );

      await updateDoc(doc(db, 'ordini', ordineInModifica.id), {
        items,
        piatti: items,
        itemStati,
        stato: nuovoStatoGlobale,
        totale,
        coperti: numeroCoperti || ordineInModifica.coperti || 0,
        notificaCategoriaInviata: ordineInModifica.notificaCategoriaInviata ?? false,
        vistoInCucina: false
      });

      setMessaggio('✅ Ordine modificato');
      setTimeout(() => setMessaggio(''), 3000);
      setOrdineInModifica(null);
    } catch (e) {
      console.error(e);
      setMessaggio('❌ Errore modifica');
      setTimeout(() => setMessaggio(''), 3000);
    }
  };

  const modificaQuantitaItemModifica = (index, delta) => {
    const items = [...ordineInModifica.items];
    const q = Math.max(1, (items[index].quantita || items[index].quantity || 1) + delta);
    items[index] = { ...items[index], quantita: q, quantity: q };
    setOrdineInModifica({ ...ordineInModifica, items });
  };

  const salvaModificaDaCarrello = async () => {
    const localeRef = doc(db, "locali", localeTag);
    const localeSnap = await getDoc(localeRef);

    if (localeSnap.exists() && localeSnap.data().stato === "bloccato") {
      setMessaggio("🚫 Locale disattivato");
      return;
    }
    if (!ordineInModifica || !tavoloSelezionato) return false;
    if (carrello.length === 0) { setMessaggio("❌ Ordine vuoto"); setTimeout(() => setMessaggio(""), 3000); return false; }
    if (numeroCoperti === 0) { setMessaggio("❌ Seleziona i coperti"); setTimeout(() => setMessaggio(""), 3000); setErroreCopertMancanti(true); return false; }
    setErroreCopertMancanti(false);
    try {
      const items = carrello.map(i => ({
        nome: i.nome || i.name || "",
        name: i.nome || i.name || "",
        prezzo: i.prezzo || i.price || 0,
        price: i.prezzo || i.price || 0,
        quantita: i.quantita || i.quantity || 1,
        quantity: i.quantita || i.quantity || 1,
        categoria: i.categoria || "",
        custom: i.custom || "",
        uid: i.uid || (Date.now().toString() + "_" + Math.random().toString(36).slice(2)),
        // ✅ Preserva stato originale — i nuovi item hanno già "inviato" da aggiungiAlCarrello
        stato: i.stato || "inviato"
      }));

      // Ricostruisce itemStati coerente con items
      const itemStati = {};
      items.forEach((item, idx) => { itemStati[String(idx)] = item.stato; });

      // Stato globale = più urgente tra tutti gli item
      const PRIORITA = ["inviato", "in attesa", "in preparazione", "pronto", "servito"];
      const statiTutti = items.map(i => i.stato || "inviato");
      const nuovoStatoGlobale = PRIORITA.find(s => statiTutti.includes(s)) || "inviato";

      const totale = items.reduce((s, i) => s + parseFloat(i.price || 0) * parseInt(i.quantita || i.quantity || 1, 10), 0);

      // Salva sul documento principale
      await updateDoc(doc(db, "ordini", ordineInModifica.id), {
        items,
        piatti: items,
        itemStati,
        stato: nuovoStatoGlobale,
        totale,
        coperti: numeroCoperti,
        notificaCategoriaInviata: ordineInModifica.notificaCategoriaInviata ?? false,
        vistoInCucina: false
      });

      // Elimina tutti gli altri documenti del tavolo (duplicati)
      const altriDocs = ordiniTavolo.filter(o => o.id !== ordineInModifica.id);
      if (altriDocs.length > 0) {
        await Promise.all(altriDocs.map(o => deleteDoc(doc(db, "ordini", o.id))));
      }

      setMessaggio(`✅ Ordine modificato per tavolo ${tavoloSelezionato.numero}`);
      setTimeout(() => setMessaggio(""), 3000);
      setOrdineInModifica(null); setCarrello([]); setMostraMenu(false); setMostraOrdini(true);
      return true;
    } catch (e) { setMessaggio("❌ Errore salvataggio"); setTimeout(() => setMessaggio(""), 3000); return false; }
  };

const segnaOrdineServito = async (ordineId) => {
  try {
    const ordineRef = doc(db, "ordini", ordineId);
    const ordineSnap = await getDoc(ordineRef);

    if (!ordineSnap.exists()) return;

    const dati = ordineSnap.data();

    const items = (dati.items || []).map((item) => {
      const stato = String(item.stato || "").toLowerCase();

      if (stato === "pronto") {
        return { ...item, stato: "servito" };
      }

      return item;
    });

    const STATI_PRIORITA = ["inviato", "in attesa", "in preparazione", "pronto", "servito"];

    const statoMin = (lista) => {
      for (const s of STATI_PRIORITA) {
        if (lista.includes(s)) return s;
      }
      return lista[0] || "inviato";
    };

    const statiTutti = items.map(i => i.stato || dati.stato || "inviato");
    const nuovoStatoGlobale = statoMin(statiTutti);

    const itemStati = {};
    items.forEach((item, index) => {
      itemStati[String(index)] = item.stato || "inviato";
    });

    const tuttoServito =
      items.length > 0 &&
      items.every((item) => String(item.stato || "").toLowerCase() === "servito");

    const updatePayload = {
      items,
      piatti: items,
      itemStati,
      stato: nuovoStatoGlobale,
      notificaServitaPronto: true
    };

    if (tuttoServito && !dati.servitoCompletamenteAt) {
      updatePayload.servitoCompletamenteAt = serverTimestamp();
    }

    await updateDoc(ordineRef, updatePayload);

    setOrdineProtiAperto(null);

  } catch (e) {
    console.error(e);
  }
};



  if (loading) return <div style={{ padding: '2rem', textAlign: 'center' }}>Caricamento...</div>;

  /* ── VISTA ORDINI TAVOLO ── */
  if (mostraOrdini && tavoloSelezionato) {
    const totaleOrdini = ordiniTavolo.reduce((s, o) => s + (o.totale || 0), 0);
    return (
      <>
        <div style={{ padding: '1rem', maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ marginBottom: '1rem' }}>
            <h2 style={{
              fontSize: '1rem',
              margin: '0 0 0.5rem 0',
              fontWeight: '700',
              color: '#fff',
              letterSpacing: '-0.02em'
            }}>
              Tavolo {tavoloSelezionato.numero}
            </h2>

            <div style={{
              fontSize: '0.78rem',
              color: '#9aa0a6',
              marginBottom: '0.75rem'
            }}>
              Gestione ordini
            </div>
            <button onClick={() => setTavoloSelezionato(null)} style={{ padding: '0.75rem 1.5rem', cursor: 'pointer', border: '1px solid #d32f2f', borderRadius: '8px', backgroundColor: '#d32f2f', color: 'white' }}>Chiudi</button>
          </div>
          {messaggio && <div style={{ padding: '0.75rem', marginBottom: '1rem', backgroundColor: messaggio.includes('✅') ? '#4CAF50' : '#f44336', color: 'white', borderRadius: '8px', textAlign: 'center' }}>{messaggio}</div>}
          <div style={{ marginBottom: '1rem', padding: '0.75rem', backgroundColor: 'var(--color-surface)', borderRadius: '8px' }}>
            <strong>Totale Tavolo: {totaleOrdini.toFixed(2)} €</strong>
          </div>
          {ordineInModifica ? (
            <div style={{
              background: "rgba(255,255,255,0.035)",
              padding: '1rem',
              borderRadius: '18px',
              marginBottom: '1rem',
              border: '1px solid rgba(255,255,255,0.06)',
              boxShadow: '0 10px 30px rgba(0,0,0,0.25)'
            }}>
              <h3 style={{ fontSize: '1.1rem', marginTop: 0 }}>Modifica Ordine</h3>
              {ordineInModifica.items?.map((item, i) => (
                <div key={i} style={{ padding: '0.5rem 0', borderBottom: '1px solid #ddd' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
                    <strong style={{ flex: '1 1 auto' }}>{item.nome || item.name}</strong>
                    <button onClick={() => modificaQuantitaItemModifica(i, -1)} style={{ padding: '0.3rem 0.6rem', backgroundColor: '#f44336', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>-</button>
                    <span style={{ minWidth: '24px', textAlign: 'center', fontWeight: '600' }}>{item.quantita || item.quantity || 1}</span>
                    <button onClick={() => modificaQuantitaItemModifica(i, 1)} style={{ padding: '0.3rem 0.6rem', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>+</button>
                    <button onClick={() => { const items = ordineInModifica.items.filter((_, idx) => idx !== i); setOrdineInModifica({ ...ordineInModifica, items }); }} style={{ padding: '0.3rem 0.6rem', backgroundColor: '#ff5722', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '0.75rem' }}>Rimuovi</button>
                  </div>
                  <input type="text" placeholder="Note" value={item.custom || ''} onChange={(e) => { const items = [...ordineInModifica.items]; items[i] = { ...items[i], custom: e.target.value }; setOrdineInModifica({ ...ordineInModifica, items }); }} style={{ marginTop: '0.4rem', width: '100%', padding: '0.45rem', borderRadius: '6px', border: '1px solid #ccc', fontSize: '0.85rem' }} />
                </div>
              ))}
              <div style={{ margin: '1rem 0', padding: '0.5rem', background: '#f7f7f7', borderRadius: '8px' }}>
                <label style={{ fontWeight: 'bold', marginRight: '0.5rem' }}>Aggiungi piatto:</label>
                <select style={{ padding: '0.4rem', borderRadius: '6px', minWidth: '160px' }} value={ordineInModifica.nuovoPiattoId || ''} onChange={e => setOrdineInModifica({ ...ordineInModifica, nuovoPiattoId: e.target.value })}>
                  <option value="">Seleziona...</option>
                  {menu.map(p => <option key={p.id || p.nome} value={p.id || p.nome}>{p.nome}</option>)}
                </select>
                <button style={{ marginLeft: '0.7rem', padding: '0.4rem 0.8rem', backgroundColor: '#2196F3', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' }}
                  onClick={() => {
                    if (!ordineInModifica.nuovoPiattoId) return;
                    const p = menu.find(x => (x.id || x.nome) === ordineInModifica.nuovoPiattoId);
                    if (!p) return;
                    const nomePiatto = p.nome || p.name || "";
                    setOrdineInModifica({
                      ...ordineInModifica,
                      items: [
                        ...ordineInModifica.items,
                        {
                          id: p.id,
                          nome: nomePiatto,
                          name: nomePiatto,
                          prezzo: p.prezzo ?? p.price ?? 0,
                          price: p.prezzo ?? p.price ?? 0,
                          custom: "",
                          quantity: 1,
                          quantita: 1,
                          categoria: p.categoria || "",
                          stato: "inviato",
                          uid: "new_" + Date.now().toString() + "_" + Math.random().toString(36).slice(2)
                        }
                      ],
                      nuovoPiattoId: ""
                    });
                  }}>Aggiungi</button>
              </div>
              <div style={{ display: 'flex', gap: '0.5rem', marginTop: '1rem' }}>
                <button onClick={salvaModificaOrdine} style={{ padding: '0.5rem 0.75rem', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '8px' }}>Salva</button>
                <button onClick={() => setOrdineInModifica(null)} style={{ padding: '0.5rem 0.75rem' }}>Annulla</button>
              </div>
            </div>
          ) : (
            <div>
              {(() => {
                // ✅ Unifica tutti i documenti del tavolo in una vista singola
                const STATI_PRIORITA = ["inviato", "in attesa", "in preparazione", "pronto", "servito"];
                const statoMinLocale = (lista) => {
                  for (const s of STATI_PRIORITA) { if (lista.includes(s)) return s; }
                  return lista[0] || "inviato";
                };

                // Raccoglie tutti gli item da tutti i documenti, con riferimento al doc di origine
                const tuttiItems = ordiniTavolo.flatMap((ordine) => {
                  const items = ordine.items || ordine.piatti || [];
                  return items.map((item, i) => ({
                    ...item,
                    _ordineId: ordine.id,
                    _localIdx: i,
                    _ordine: ordine,
                    // ✅ FIX: legge stato corretto come nel MenuView
                    _stato:
                      item.stato ||
                      ordine.itemStati?.[String(i)] ||
                      ordine.stato ||
                      "inviato",
                  }));
                });

                // Stato globale = stato più urgente tra tutti gli item
                const statiTutti = tuttiItems.map(it => it._stato || "inviato");
                const statoGlobale = statoMinLocale(statiTutti);

                // Totale complessivo
                const totaleComplessivo = ordiniTavolo.reduce((s, o) => s + (o.totale || 0), 0);

                // Colore badge stato item
                const coloreStato = (stato) => {
                  if (stato === "pronto") return "#4CAF50";
                  if (stato === "in preparazione") return "#FF9800";
                  if (stato === "servito") return "#9E9E9E";
                  return "transparent";
                };

                // Per modifica: usa il primo documento attivo
                const primoOrdine = ordiniTavolo[0];

                return (
                  <div style={{ backgroundColor: 'var(--color-surface)', padding: '1rem', borderRadius: '8px', marginBottom: '1rem' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem', gap: '1rem' }}>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        fontSize: '0.85rem',
                        fontWeight: '700',
                        color: '#fff'
                      }}>
                        {statoGlobale === "pronto" && "🟢 Pronto"}
                        {statoGlobale === "in preparazione" && "🟠 In preparazione"}
                        {statoGlobale === "servito" && "⚪ Servito"}
                        {statoGlobale === "inviato" && "🔵 Inviato"}
                      </div>
                      <span style={{
                        color: '#34c759',
                        fontWeight: '800',
                        fontSize: '0.95rem',
                        letterSpacing: '-0.02em'
                      }}>{totaleComplessivo.toFixed(2)} €</span>
                    </div>
                    <div style={{ marginBottom: '1rem' }}>
                      {(() => {
                        const grouped = {};

                        tuttiItems.forEach((item) => {
                          const stato = item._stato || item.stato || "inviato";
                          const nome = item.nome || item.name || "";

                          const key = `${nome}_${item.custom || ""}_${stato}`;

                          if (!grouped[key]) {
                            grouped[key] = {
                              ...item,
                              name: nome,
                              quantity: 0
                            };
                          }

                          grouped[key].quantity += item.quantity || item.quantita || 1;
                        });

                        return Object.values(grouped).map((item, i) => (
                          <div
                            key={i}
                            className="item-row"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              padding: "10px 12px",
                              borderRadius: "14px",
                              background: "rgba(255,255,255,0.03)",
                              border: "1px solid rgba(255,255,255,0.05)",
                              marginBottom: "6px"
                            }}
                          >
                            <div className="item-text" style={{ flex: 1 }}>
                              <span style={{
                                fontWeight: "700",
                                color: "#fff",
                                fontSize: "0.9rem"
                              }}>
                                {item.quantity} × {item.nome || item.name}
                              </span>

                              {/* 🔥 STATO PIATTO */}
                              <div
                                style={{
                                  marginTop: "6px",
                                  fontSize: "0.72rem",
                                  fontWeight: "700",
                                  padding: "4px 8px",
                                  borderRadius: "999px",
                                  display: "inline-block",
                                  background:
                                    item._stato === "pronto"
                                      ? "rgba(52,199,89,0.15)"
                                      : item._stato === "in preparazione"
                                      ? "rgba(255,159,10,0.15)"
                                      : item._stato === "servito"
                                      ? "rgba(142,142,147,0.15)"
                                      : "rgba(255,255,255,0.05)",
                                  color:
                                    item._stato === "pronto"
                                      ? "#34c759"
                                      : item._stato === "in preparazione"
                                      ? "#ff9f0a"
                                      : item._stato === "servito"
                                      ? "#8e8e93"
                                      : "#c7c7cc"
                                }}
                              >
                                {item._stato}
                              </div>

                              {item.custom && (
                                <div className="ordine-info">{item.custom}</div>
                              )}
                            </div>
                          </div>
                        ));
                      })()}
                    </div>
                    <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                      <button onClick={() => {
                        // Modifica: carica tutti gli item unificati nel primo documento
                        const norm = tuttiItems.map((item) => {
                          const nome = item.nome || item.name || "";
                          if (!nome) return null;
                          const p = menu.find(x => x.nome === nome);
                          return {
                            id: p?.id || `${item._ordineId}_${item._localIdx}`,
                            nome, name: nome,
                            prezzo: item.prezzo ?? item.price ?? p?.prezzo ?? 0,
                            price: item.prezzo ?? item.price ?? p?.prezzo ?? 0,
                            quantita: parseInt(item.quantita ?? item.quantity ?? 1, 10) || 1,
                            quantity: parseInt(item.quantita ?? item.quantity ?? 1, 10) || 1,
                            custom: item.custom || "",
                            categoria: item.categoria || p?.categoria || "",
                            stato: item._stato || item.stato || "inviato",
                            uid: item.uid || `${item._ordineId}_${item._localIdx}`
                          };
                        }).filter(Boolean);
                        setCarrello(norm);
                        setOrdineInModifica({ ...primoOrdine, items: norm });
                        setNumeroCoperti(primoOrdine?.coperti || 0);
                        setMostraOrdini(false); setMostraMenu(true);
                      }} style={{ padding: '0.6rem 1rem', backgroundColor: '#2196F3', color: 'white', border: 'none', borderRadius: '8px' }}>Modifica</button>
                      <button
                        onClick={eliminaOrdine}
                        style={{
                          padding: '0.6rem 1rem',
                          background: 'rgba(255,59,48,0.15)',
                          color: '#ff453a',
                          border: '1px solid rgba(255,59,48,0.25)',
                          borderRadius: '8px'
                        }}
                      >
                        Elimina
                      </button>
                    </div>
                  </div>
                );
              })()}
            </div>
          )}
        </div>
        <audio ref={audioRef} src="/notification.mp3" preload="auto" />
      </>
    );
  }

  /* ── VISTA MENU TAVOLO ── */
  if (mostraMenu && tavoloSelezionato) {
    const piattiCategoria = menu.filter(p => p.categoria === categoriaSelezionata);
    const totaleCarrello = carrello.reduce((s, i) => s + parseFloat(i.prezzo) * i.quantita, 0);
    const totalePezzi = carrello.reduce((s, i) => s + i.quantita, 0);
    return (
      <div className="cameriere-menu-container">
        <header className="cameriere-menu-header">
          <div className="header-right">
            <button className="cameriere-btn carrello-btn" onClick={() => setShowRiepilogo(!showRiepilogo)}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M6 6h15l-1.5 9h-12z" stroke="white" strokeWidth="2" /><circle cx="9" cy="21" r="1.5" fill="white" /><circle cx="18" cy="21" r="1.5" fill="white" /></svg>
              {totalePezzi > 0 ? ` ${totalePezzi}` : ''}
            </button>
            <button className="cameriere-btn close-btn" onClick={() => { setMostraMenu(false); setMostraOrdini(false); setTavoloSelezionato(null); setCarrello([]); setOrdineInModifica(null); setNumeroCoperti(0); }}>✕</button>
          </div>
        </header>
        <nav className="cameriere-categorie-navbar">
          <div className="cameriere-categorie-container">
            {categorie.map(cat => <button key={cat.id} className={`cameriere-categoria-btn ${categoriaSelezionata === cat.nome ? 'active' : ''}`} onClick={() => setCategoriaSelezionata(cat.nome)}>{cat.nome}</button>)}
          </div>
        </nav>
        <div className="cameriere-menu-spacer" />
        <div className="cameriere-piatti-container">
          <div className="cameriere-piatti-grid">
            {piattiCategoria.map(piatto => {
              const qty = carrello.filter(i => i.id === piatto.id).reduce((s, i) => s + i.quantita, 0);
              return (
                <div key={piatto.id} className={`cameriere-piatto-card ${qty > 0 ? 'in-carrello' : ''}`}>
                  {qty > 0 && <div className="cameriere-badge-qty">{qty}</div>}
                  <div className="cameriere-piatto-header"><div className="cameriere-piatto-nome">{piatto.nome}</div></div>
                  {piatto.descrizione && <div className="cameriere-piatto-descrizione">{piatto.descrizione}</div>}
                  <div className="cameriere-note-row">
                    <input type="text" className="cameriere-piatto-note" placeholder="Note" value={inputValori[piatto.id]?.custom || ""} onChange={(e) => setInputValori(prev => ({ ...prev, [piatto.id]: { ...(prev[piatto.id] || {}), custom: e.target.value } }))} />
                    <button className="cameriere-btn-aggiungi ios-inline" onClick={() => aggiungiAlCarrello(piatto)}>+</button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        {showRiepilogo && (
          <div className="cameriere-riepilogo-overlay" onClick={() => setShowRiepilogo(false)}>
            <div
              className="cameriere-riepilogo-panel"
              onClick={(e) => e.stopPropagation()}
              style={{
                background: "rgba(18,18,20,0.96)",
                backdropFilter: "blur(18px)",
                border: "1px solid rgba(255,255,255,0.06)",
                boxShadow: "0 20px 60px rgba(0,0,0,0.45)",
                borderRadius: "24px 24px 0 0"
              }}
            >
              <div
                className="cameriere-riepilogo-header"
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 5,
                  background: "rgba(18,18,20,0.94)",
                  backdropFilter: "blur(16px)",
                  borderBottom: "1px solid rgba(255,255,255,0.06)",
                  paddingBottom: "0.9rem"
                }}
              >
                <div
                  style={{
                    width: "42px",
                    height: "5px",
                    borderRadius: "999px",
                    background: "rgba(255,255,255,0.18)",
                    margin: "0 auto 12px auto"
                  }}
                />

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "12px"
                  }}
                >
                  <div style={{ minWidth: 0 }}>
                    <div
                      className="cameriere-riepilogo-title"
                      style={{
                        fontSize: "1rem",
                        fontWeight: "700",
                        color: "#fff",
                        letterSpacing: "-0.02em"
                      }}
                    >
                      Riepilogo ordine
                    </div>
                    <div
                      style={{
                        fontSize: "0.78rem",
                        color: "#9aa0a6",
                        marginTop: "2px"
                      }}
                    >
                      Tavolo {tavoloSelezionato.numero}
                    </div>
                  </div>

                  <button
                    className="cameriere-riepilogo-close"
                    onClick={() => { setShowRiepilogo(false); setErroreCopertMancanti(false); }}
                    style={{
                      width: "36px",
                      height: "36px",
                      borderRadius: "999px",
                      border: "1px solid rgba(255,255,255,0.08)",
                      background: "rgba(255,255,255,0.04)",
                      color: "#fff",
                      fontSize: "1rem",
                      fontWeight: "700"
                    }}
                  >
                    ✕
                  </button>
                </div>
              </div>
              {carrello.length === 0 ? (
                <div
                  className="cameriere-riepilogo-empty"
                  style={{
                    padding: "1.25rem",
                    textAlign: "center",
                    color: "#9aa0a6",
                    background: "rgba(255,255,255,0.03)",
                    border: "1px solid rgba(255,255,255,0.05)",
                    borderRadius: "18px"
                  }}
                >
                  Nessun piatto selezionato
                </div>
              ) : (
                carrello.map((item, index) => (
                  <div
                    key={item.uid || `${item.id}_${index}`}
                    className="cameriere-riepilogo-item"
                    style={{
                      background: "rgba(255,255,255,0.035)",
                      border: "1px solid rgba(255,255,255,0.06)",
                      borderRadius: "18px",
                      padding: "12px 12px",
                      marginBottom: "10px",
                      boxShadow: "0 8px 24px rgba(0,0,0,0.18)",
                      alignItems: "center"
                    }}
                  >
                    <div className="cameriere-riepilogo-item-info" style={{ minWidth: 0, flex: 1 }}>
                      <div
                        className="cameriere-riepilogo-item-nome"
                        style={{
                          fontSize: "0.96rem",
                          fontWeight: "700",
                          color: "#fff",
                          lineHeight: 1.15
                        }}
                      >
                        {item.nome}
                      </div>

                      {item.custom && (
                        <div
                          style={{
                            fontSize: "0.74rem",
                            color: "#b0b6bd",
                            marginTop: "5px",
                            lineHeight: 1.25,
                            wordBreak: "break-word"
                          }}
                        >
                          📝 {item.custom}
                        </div>
                      )}
                    </div>
                    <div
                      className="cameriere-riepilogo-item-qty"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        padding: "4px",
                        borderRadius: "999px",
                        background: "rgba(255,255,255,0.04)",
                        border: "1px solid rgba(255,255,255,0.06)"
                      }}
                    >
                      <button
                        className="cameriere-riepilogo-qty-btn minus"
                        onClick={() => modificaQuantita(item.uid, null, item.quantita - 1)}
                        style={{
                          width: "28px",
                          height: "28px",
                          borderRadius: "999px",
                          border: "none",
                          background: "rgba(255,255,255,0.08)",
                          color: "#fff",
                          fontWeight: "700"
                        }}
                      >
                        −
                      </button>

                      <span
                        className="cameriere-riepilogo-qty-num"
                        style={{
                          minWidth: "22px",
                          textAlign: "center",
                          fontWeight: "700",
                          color: "#fff",
                          fontSize: "0.86rem"
                        }}
                      >
                        {item.quantita}
                      </span>

                      <button
                        className="cameriere-riepilogo-qty-btn plus"
                        onClick={() => modificaQuantita(item.uid, null, item.quantita + 1)}
                        style={{
                          width: "28px",
                          height: "28px",
                          borderRadius: "999px",
                          border: "none",
                          background: "#0a84ff",
                          color: "#fff",
                          fontWeight: "700"
                        }}
                      >
                        +
                      </button>
                    </div>
                    <div
                      className="cameriere-riepilogo-item-stato"
                      style={{
                        fontSize: "0.72rem",
                        fontWeight: "700",
                        padding: "6px 10px",
                        borderRadius: "999px",
                        letterSpacing: "0.01em",
                        whiteSpace: "nowrap",
                        background:
                          item.stato === "pronto"
                            ? "rgba(52,199,89,0.16)"
                            : item.stato === "in preparazione"
                            ? "rgba(255,159,10,0.16)"
                            : item.stato === "servito"
                            ? "rgba(142,142,147,0.16)"
                            : "rgba(255,255,255,0.06)",
                        color:
                          item.stato === "pronto"
                            ? "#34c759"
                            : item.stato === "in preparazione"
                            ? "#ff9f0a"
                            : item.stato === "servito"
                            ? "#8e8e93"
                            : "#c7c7cc",
                        border:
                          item.stato === "pronto"
                            ? "1px solid rgba(52,199,89,0.22)"
                            : item.stato === "in preparazione"
                            ? "1px solid rgba(255,159,10,0.22)"
                            : item.stato === "servito"
                            ? "1px solid rgba(142,142,147,0.2)"
                            : "1px solid rgba(255,255,255,0.05)"
                      }}
                    >
                      {item.stato === "pronto"
                        ? "● Pronto"
                        : item.stato === "in preparazione"
                        ? "● In prep."
                        : item.stato === "servito"
                        ? "● Servito"
                        : "● Inviato"}
                    </div>
                    <button
                      className="cameriere-riepilogo-item-delete"
                      onClick={() => rimuoviDalCarrello(item.uid)}
                      style={{
                        width: "30px",
                        height: "30px",
                        borderRadius: "999px",
                        border: "1px solid rgba(255,255,255,0.06)",
                        background: "rgba(255,59,48,0.12)",
                        color: "#ff453a",
                        fontWeight: "700",
                        flexShrink: 0
                      }}
                    >
                      ✕
                    </button>
                  </div>
                ))
              )}
              {carrello.length > 0 && (
                <div
                  className="cameriere-riepilogo-footer"
                  style={{
                    position: "sticky",
                    bottom: 0,
                    background: "rgba(18,18,20,0.97)",
                    backdropFilter: "blur(18px)",
                    borderTop: "1px solid rgba(255,255,255,0.06)",
                    marginTop: "12px",
                    paddingTop: "14px"
                  }}
                >
                  <div style={{ marginBottom: '0.8rem' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.3rem', marginBottom: '0.4rem', fontSize: '0.85rem', fontWeight: '600' }}>
                      <span>Coperti:</span>
                      <button onClick={() => setNumeroCoperti(Math.max(0, numeroCoperti - 1))} style={{ padding: '0.2rem 0.5rem', borderRadius: '4px', border: 'none', cursor: 'pointer', backgroundColor: '#f44336', color: 'white' }}>−</button>
                      <span style={{ minWidth: '24px', textAlign: 'center', fontWeight: 'bold' }}>{numeroCoperti}</span>
                      <button onClick={() => setNumeroCoperti(numeroCoperti + 1)} style={{ padding: '0.2rem 0.5rem', borderRadius: '4px', border: 'none', cursor: 'pointer', backgroundColor: '#4CAF50', color: 'white' }}>+</button>
                    </div>
                    <div className="cameriere-coperti-grid" style={{ display: 'flex', flexWrap: 'wrap', gap: '0.25rem' }}>
                      {[1,2,3,4,5,6,7,8,9,10,11,12].map(n => <button key={n} onClick={() => setNumeroCoperti(n)} className={numeroCoperti === n ? 'active' : ''}>{n}</button>)}
                    </div>
                  </div>
                  {erroreCopertMancanti && numeroCoperti === 0 && (
                    <div style={{ padding: '0.5rem', backgroundColor: 'rgba(244,67,54,0.2)', color: '#ff8a80', borderRadius: '6px', marginBottom: '0.75rem', fontSize: '0.85rem', fontWeight: 'bold', textAlign: 'center', border: '1px solid #f44336' }}>⚠️ Seleziona il numero di coperti!</div>
                  )}
                  <div
                    className="cameriere-riepilogo-totale"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "12px 14px",
                      borderRadius: "16px",
                      background: "rgba(255,255,255,0.04)",
                      border: "1px solid rgba(255,255,255,0.06)",
                      marginBottom: "12px"
                    }}
                  >
                    <span style={{ color: "#9aa0a6", fontSize: "0.88rem", fontWeight: "600" }}>
                      Totale ordine
                    </span>
                    <span
                      className="cameriere-riepilogo-totale-value"
                      style={{
                        color: "#fff",
                        fontSize: "1.05rem",
                        fontWeight: "800",
                        letterSpacing: "-0.02em"
                      }}
                    >
                      {totaleCarrello.toFixed(2)} €
                    </span>
                  </div>
                  <button
                    className="cameriere-btn-invia"
                    onClick={async () => {
                      if (ordineInModifica) {
                        const r = await salvaModificaDaCarrello();
                        if (r === true) setShowRiepilogo(false);
                      } else {
                        const r = await inviaOrdine();
                        if (r === true) setShowRiepilogo(false);
                      }
                    }}
                    style={{
                      width: "100%",
                      height: "52px",
                      borderRadius: "16px",
                      border: "none",
                      background: "linear-gradient(135deg, #0a84ff, #0066ff)",
                      color: "#fff",
                      fontWeight: "800",
                      fontSize: "0.98rem",
                      boxShadow: "0 12px 24px rgba(10,132,255,0.28)"
                    }}
                  >
                    ✓ Invia ordine
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
        <audio ref={audioRef} src="/notification.mp3" preload="auto" />
      </div>
    );
  }

  /* ── VISTA PRINCIPALE ── */
  const prontiPerTavolo = {};

  Object.values(prontiPerOrdine).forEach(({ tavolo, items, ordine }) => {
    if (!prontiPerTavolo[tavolo]) {
      prontiPerTavolo[tavolo] = {
        items: [],
        ordini: []
      };
    }

    prontiPerTavolo[tavolo].items.push(...items);
    prontiPerTavolo[tavolo].ordini.push(ordine);
  });

const renderTavoloCard = (tavolo) => {
  const haChiamata = chiamateServizio.some(
    c => String(c.tavolo) === String(tavolo.numero) && c.locale === localeTag
  );

  const nPronti = badgeProntiPerTavolo[tavolo.numero] || 0;

  const haAlertAI = tavolo.alertAI?.length > 0;

  const colorClass =
    tavolo.impegnato
      ? 'card-occupied'
      : tavolo.clientePresente
        ? 'card-pending'
        : 'card-available';

  return (
    <div
      key={tavolo.id}
      className={`responsive-card tavolo-card-compatta ${colorClass} ${haChiamata ? 'card-chiamata-servizio' : ''}`}
      onClick={() => {
        if (haAlertAI) {
          setAlertAISelezionato(tavolo);
          return;
        }

        apriMenuTavolo(tavolo);
      }}
    >
      <div style={{ position: "relative", paddingTop: "10px", paddingRight: "10px" }}>
        <div className="card-number">
          {tavolo.numero}
        </div>

        {haAlertAI && (
          <div
            style={{
              position: "absolute",
              top: "-6px",
              left: "50%",
              transform: "translateX(-50%)",
              background: "linear-gradient(135deg, #ff3b30, #ff6b6b)",
              color: "#fff",
              fontSize: "0.62rem",
              fontWeight: "800",
              borderRadius: "999px",
              padding: "2px 7px",
              boxShadow: "0 4px 10px rgba(255,59,48,0.35)",
              whiteSpace: "nowrap",
              zIndex: 3
            }}
          >
            🚨 ALERT
          </div>
        )}

        {nPronti > 0 && (
          <div style={{
            position: "absolute",
            top: "0px",
            right: "0px",
            transform: "translate(18%, -18%)",
            background: "linear-gradient(135deg, #ff3b30, #ff6b6b)",
            color: "white",
            fontSize: "0.7rem",
            fontWeight: "700",
            borderRadius: "999px",
            padding: "2px 6px",
            minWidth: "18px",
            textAlign: "center",
            boxShadow: "0 2px 6px rgba(0,0,0,0.3)"
          }}>
            {nPronti}
          </div>
        )}
      </div>
    </div>
  );
};

  return (
    <>
      {localeBloccato && (
        <div style={{
          position: "fixed",
          inset: 0,
          zIndex: 999999,
          background: "#0f0f12",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          color: "#fff",
          textAlign: "center",
          padding: "2rem"
        }}>
          <div style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>🚫</div>
          <h2>Locale disattivato</h2>
          <p style={{ color: "#aaa" }}>Contatta l'amministratore</p>
        </div>
      )}
      {showPushPopup && (
        <div className="modal-overlay">
          <div
            className="app-modal"
            style={{
              textAlign: "center",
              padding: "2rem",
              borderRadius: "20px",
              background: "rgba(20,20,22,0.9)",
              backdropFilter: "blur(20px)",
              border: "1px solid rgba(255,255,255,0.08)"
            }}
          >
            <div style={{ fontSize: "2rem", marginBottom: "1rem" }}>🔔</div>

            <h3 style={{ marginBottom: "0.5rem" }}>
              Attiva le notifiche
            </h3>

            <p style={{ fontSize: "0.9rem", color: "#aaa", marginBottom: "1.5rem" }}>
              Riceverai i piatti pronti anche a schermo spento.
            </p>

            <button
              onClick={enableNotificationsManually}
              style={{
                width: "100%",
                padding: "14px",
                borderRadius: "14px",
                border: "none",
                background: "#0a84ff",
                color: "#fff",
                fontWeight: "600",
                marginBottom: "10px"
              }}
            >
              Attiva notifiche
            </button>

            <button
              onClick={() => setShowPushPopup(false)}
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "14px",
                background: "transparent",
                border: "1px solid rgba(255,255,255,0.1)",
                color: "#aaa"
              }}
            >
              Dopo
            </button>
          </div>
        </div>
      )}
      {/* ── STANDBY OVERLAY ── */}
      {isStandby && (
        <div
          onClick={toggleStandby}
          style={{
            position: 'fixed', inset: 0, zIndex: 99999,
            background: 'rgba(0,0,0,0.97)',
            display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center',
            gap: '1.5rem', cursor: 'pointer',
            userSelect: 'none',
          }}
        >
          <div style={{ fontSize: '4.5rem', fontWeight: '100', color: 'white', letterSpacing: '-2px', fontVariantNumeric: 'tabular-nums' }}>
            {oraNow.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' })}
          </div>
          <div style={{ fontSize: '1rem', color: 'rgba(255,255,255,0.45)', fontWeight: '400' }}>
            {nomeCameriere} · In standby
          </div>
          <div style={{ marginTop: '2rem', fontSize: '0.85rem', color: 'rgba(255,255,255,0.22)', letterSpacing: '0.1em', textTransform: 'uppercase' }}>
            Tocca per riprendere
          </div>
          <div style={{ fontSize: '2rem', opacity: 0.18 }}>⏸</div>
        </div>
      )}

      <div className="page-with-navbar responsive-cameriere-container">

        {/* HEADER */}
        <div className="app-header" style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0.75rem 1rem',
          background: 'rgba(20,20,22,0.75)',
          backdropFilter: 'blur(20px)',
          borderBottom: '1px solid rgba(255,255,255,0.05)',
          position: 'sticky',
          top: 0,
          zIndex: 1000
        }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: '0.95rem', fontWeight: '700', color: 'var(--color-text)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {infoLocale.nome || '—'}
            </div>
            <div style={{ fontSize: '0.78rem', display: 'flex', alignItems: 'center', gap: '4px' }}>
              {/* FIX: nome cameriere ora usa color-text invece di color-muted */}
              <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'var(--color-text)', fontWeight: '500' }}>{nomeCameriere || '—'}</span>
              {isStandby
                ? <span style={{ marginLeft: '6px', fontSize: '0.68rem', background: '#FF9800', color: 'white', borderRadius: '999px', padding: '1px 6px' }}>⏸ STANDBY</span>
                : pushAbilitato
                  ? <span style={{ marginLeft: '6px', fontSize: '0.68rem', background: '#4CAF50', color: 'white', borderRadius: '999px', padding: '1px 6px' }}>🔔 ON</span>
                  : <span style={{ marginLeft: '6px', fontSize: '0.68rem', background: '#9E9E9E', color: 'white', borderRadius: '999px', padding: '1px 6px' }}>🔕 OFF</span>
              }
            </div>
          </div>

          {isDemo && (
  <button
    onClick={tornaAllaDashboardDemo}
    style={{
      height: '38px',
      padding: '0 14px',
      borderRadius: '12px',
      border: '1px solid rgba(255,255,255,0.08)',
      background: 'rgba(255,255,255,0.06)',
      color: '#fff',
      fontWeight: '700',
      fontSize: '0.85rem',
      cursor: 'pointer',
      backdropFilter: 'blur(12px)',
      WebkitBackdropFilter: 'blur(12px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '6px',
      marginRight: '10px',
      flexShrink: 0
    }}
  >
    ← Demo
  </button>
)}

          {/* HAMBURGER */}
          <div ref={userMenuRef} style={{ position: 'relative', flexShrink: 0 }}>
            <button onClick={() => setShowUserMenu(p => !p)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '8px', display: 'flex', flexDirection: 'column', gap: '5px', alignItems: 'center', justifyContent: 'center' }} aria-label="Menu">
              <span style={{ display: 'block', width: '22px', height: '2px', background: 'var(--color-text)', borderRadius: '2px' }} />
              <span style={{ display: 'block', width: '22px', height: '2px', background: 'var(--color-text)', borderRadius: '2px' }} />
              <span style={{ display: 'block', width: '22px', height: '2px', background: 'var(--color-text)', borderRadius: '2px' }} />
            </button>
            {showUserMenu && (
              <div style={{ position: 'absolute', right: 0, top: '48px', minWidth: '220px', background: 'var(--color-surface)', border: '1px solid var(--color-border)', borderRadius: '14px', boxShadow: '0 8px 32px rgba(0,0,0,0.18)', zIndex: 999, overflow: 'hidden' }}>
                {/* STANDBY */}
                <div onClick={toggleStandby} style={{ padding: '14px 18px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '12px', borderBottom: '1px solid var(--color-border)', fontSize: '0.9rem' }}>
                  <span style={{ fontSize: '1.2rem' }}>{isStandby ? '▶️' : '⏸️'}</span>
                  <div>
                    <div style={{ fontWeight: '600' }}>{isStandby ? 'Riprendi turno' : 'Standby'}</div>
                    <div style={{ fontSize: '0.75rem', color: 'var(--color-muted)' }}>{isStandby ? 'Torna operativo' : 'Pausa — silenzia tutto'}</div>
                  </div>
                </div>
                <div onClick={handleLogout} style={{ padding: '14px 18px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '12px', fontSize: '0.9rem', color: '#f44336' }}>
                  <span style={{ fontSize: '1.2rem' }}>🔓</span>
                  <div>
                    <div style={{ fontWeight: '600' }}>Logout</div>
                    <div style={{ fontSize: '0.75rem', color: 'var(--color-muted)' }}>Nuova configurazione</div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* CARD PIATTI PRONTI */}
        {Object.keys(prontiPerTavolo).length > 0 && (
          <div style={{ 
            background: 'rgba(10,132,255,0.08)',
            padding: '0.8rem',
            borderRadius: '12px',
            marginBottom: '0.75rem',
            border: '1px solid rgba(10,132,255,0.25)'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.6rem', fontSize: '0.85rem', color: '#0a84ff', fontWeight: '600' }}>
              🍽️ Piatti pronti — ({Object.values(prontiPerTavolo).reduce((s, v) => s + v.items.length, 0)})
            </div>
            <div className="pronti-premium-grid">
              {Object.entries(prontiPerTavolo).map(([tavolo, data]) => {
                const piattiGrouped = raggruppaPiatti(data.items);
                const totale = data.items.length;

                return (
                  <div
                    key={tavolo}
                    className="pronti-premium-card"
                    style={{
                      background: "linear-gradient(135deg, #0a84ff22, #0a84ff10)",
                      border: "1px solid rgba(10,132,255,0.25)",
                      boxShadow: "0 4px 20px rgba(10,132,255,0.15)"
                    }}
                    onClick={() =>
                      setOrdineProtiAperto({
                        tavolo,
                        items: data.items,
                        ordini: [...new Map(data.ordini.map(o => [o.id, o])).values()]
                      })
                    }
                  >
                    {/* HEADER */}
                    <div className="pp-header">
                      <span className="pp-tavolo">Tav. {tavolo}</span>
                      <span className="pp-badge">{totale}</span>
                    </div>

                    {/* LISTA PIATTI */}
                    <div className="pp-items">
                      {piattiGrouped.slice(0, 3).map((item, i) => (
                        <div
                          key={i}
                          className="pp-item"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "2px"
                          }}
                        >
                          <div style={{ display: "flex", alignItems: "center", gap: "6px", minWidth: 0 }}>
                            <span className="pp-qty">{item.qty}×</span>
                            <span className="pp-name">{item.nome}</span>
                          </div>

                          {item.custom && (
                            <div
                              style={{
                                fontSize: "0.68rem",
                                color: "#e6f2ff",
                                opacity: 1,
                                paddingLeft: "24px",
                                lineHeight: 1.2,
                                wordBreak: "break-word"
                              }}
                            >
                              📝 {item.custom}
                            </div>
                          )}
                        </div>
                      ))}

                      {piattiGrouped.length > 3 && (
                        <div className="pp-more">
                          +{piattiGrouped.length - 3} altri
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {messaggio && <div style={{ padding: '0.75rem', marginBottom: '1rem', backgroundColor: messaggio.includes('Errore') ? '#f44336' : '#4CAF50', color: 'white', borderRadius: '8px', textAlign: 'center' }}>{messaggio}</div>}

        {/* CHIAMATE SERVIZIO */}
        {chiamateServizio.length > 0 && (
          <div style={{ backgroundColor: '#FFF3E0', padding: '0.8rem', borderRadius: '8px', marginBottom: '0.75rem', border: '2px solid #FF9800' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.6rem', fontSize: '0.85rem', color: '#E65100', fontWeight: '600' }}>
              🔔 Chiamate Servizio ({chiamateServizio.length})
            </div>
            <div className="notifica-mini-grid">
              {chiamateServizio.map(c => (
                <div key={c.id} className="notifica-mini-card notifica-servizio" onClick={() => gestisciChiamataServizio(c.id)}>
                  {c.tavolo || c.table || '?'}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* CATEGORIA NOTIFICA */}
        {ordiniCategoriaNotifica.length > 0 && categoriaNotifica && (() => {

          const categoriePerTavolo = {};

          ordiniCategoriaNotifica.forEach(o => {
            const tavolo = o.table || o.tavolo;

            if (!categoriePerTavolo[tavolo]) {
              categoriePerTavolo[tavolo] = {
                items: [],
                ordini: []
              };
            }

            (o.items || []).forEach(item => {
              const nome = item.name || item.nome || "";
              const stato = String(item.stato || "").toLowerCase();

              if (stato === "servito") return;

              const piatto = menu.find(p => p.nome === nome || p.name === nome);
              const categoria = item.categoria || item.category || piatto?.categoria || "";

              if (categoriaNotifica.includes(categoria)) {
                categoriePerTavolo[tavolo].items.push({
                  nome,
                  custom: item.custom || ""
                });
              }
            });

            categoriePerTavolo[tavolo].ordini.push(o);
          });

          return (
            <div
              style={{
                backgroundColor: '#E8F5E9',
                padding: '0.8rem',
                borderRadius: '8px',
                marginBottom: '0.75rem',
                border: '2px solid #4CAF50'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  marginBottom: '0.6rem',
                  fontSize: '0.85rem',
                  color: '#2E7D32',
                  fontWeight: '600'
                }}
              >
                🥤 {categoriaNotifica.join(", ")} (
                {Object.values(categoriePerTavolo).reduce((s, v) => s + v.items.length, 0)}
                )
              </div>

              <div className="pronti-premium-grid">
                {Object.entries(categoriePerTavolo).map(([tavolo, data]) => {

                  const grouped = {};

                  data.items.forEach((item) => {
                    const key = `${item.nome}__${item.custom}`;

                    if (!grouped[key]) {
                      grouped[key] = {
                        nome: item.nome,
                        custom: item.custom,
                        qty: 0
                      };
                    }

                    grouped[key].qty += 1;
                  });

                  const itemsGrouped = Object.values(grouped);

                  return (
                    <div
                      key={tavolo}
                      className="pronti-premium-card"
                      onClick={() =>
                        setDettagliOrdineAperto({
                          tavolo,
                          items: data.items,
                          ordini: data.ordini,
                          id: data.ordini?.[0]?.id || null
                        })
                      }
                    >
                      <div className="pp-header">
                        <span className="pp-tavolo">Tav. {tavolo}</span>
                        <span className="pp-badge">{data.items.length}</span>
                      </div>

                      <div className="pp-items">
                        {itemsGrouped.slice(0, 3).map((item, i) => (
                          <div key={i} className="pp-item">
                            <span className="pp-qty">{item.qty}×</span>
                            <span className="pp-name">{item.nome}</span>
                          </div>
                        ))}

                        {itemsGrouped.length > 3 && (
                          <div className="pp-more">
                            +{itemsGrouped.length - 3} altri
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })()}

        {/* INSTALL BANNER */}
        {showInstallBanner && (
          <div className="app-modal" style={{ position: "fixed", top: "20px", left: "50%", transform: "translateX(-50%)", backdropFilter: "blur(12px)", border: "1px solid rgba(0,0,0,0.06)", zIndex: 9999, padding: "16px" }}>
            <div style={{ fontWeight: 800, marginBottom: "6px" }}>📲 Installa QrMenu Cameriere</div>
            <div style={{ fontSize: "13px", color: "#555", marginBottom: "12px" }}>Ricevi notifiche anche a schermo spento.</div>
            <div style={{ display: "flex", gap: "8px" }}>
              <button onClick={async () => { const dp = window.__WAITerInstallPrompt; if (!dp) return; dp.prompt(); window.__WAITerInstallPrompt = null; setShowInstallBanner(false); }} style={{ flex: 1, padding: "10px", borderRadius: "12px", border: "none", background: "#111", color: "#fff", fontWeight: 700, cursor: "pointer" }}>Installa</button>
              <button onClick={() => { localStorage.setItem("waiter_install_dismissed", "true"); setShowInstallBanner(false); }} style={{ flex: 1, padding: "10px", borderRadius: "12px", border: "1px solid rgba(0,0,0,0.15)", background: "transparent", fontWeight: 600, cursor: "pointer" }}>Dopo</button>
            </div>
          </div>
        )}


{aiSalaInsights.length > 0 && (
  <div
    style={{
      background: `
        linear-gradient(
          145deg,
          rgba(28,28,30,0.96),
          rgba(18,18,20,0.98)
        )
      `,
      border: "1px solid rgba(139,92,246,0.22)",
      borderRadius: "22px",
      padding: "1rem",
      marginBottom: "1rem",
      boxShadow: `
        0 0 30px rgba(139,92,246,0.12),
        0 10px 30px rgba(0,0,0,0.28)
      `,
      backdropFilter: "blur(18px)"
    }}
  >

    {/* HEADER */}
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: "1rem"
      }}
    >

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.55rem",
          fontSize: "1rem",
          fontWeight: "700",
          color: "#fff"
        }}
      >
        🤖 Assistente AI Sala
      </div>

      <div
        style={{
          padding: "0.25rem 0.6rem",
          borderRadius: "999px",
          fontSize: "0.68rem",
          fontWeight: "700",
          background: "rgba(139,92,246,0.16)",
          color: "#c4b5fd",
          border: "1px solid rgba(139,92,246,0.28)"
        }}
      >
        LIVE
      </div>

    </div>

    {/* INSIGHTS */}
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "0.7rem"
      }}
    >

      {aiSalaInsights.map((insight, index) => {

        const isAlta = insight.priority === "alta";

        return (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.7rem",
              padding: "0.85rem 0.95rem",
              borderRadius: "16px",
              background: "rgba(255,255,255,0.04)",
              border: `
                1px solid ${
                  isAlta
                    ? "rgba(255,59,48,0.18)"
                    : "rgba(255,255,255,0.05)"
                }
              `
            }}
          >

            {/* ICONA */}
            <div
              style={{
                width: "38px",
                height: "38px",
                borderRadius: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                fontSize: "1rem",
                background: isAlta
                  ? "rgba(255,59,48,0.16)"
                  : "rgba(255,149,0,0.16)",
                color: isAlta
                  ? "#ff6b6b"
                  : "#ffb84d"
              }}
            >
              {insight.type === "pronti" && "🍽️"}
              {insight.type === "servizio" && "🔔"}
              {insight.type === "chiamata_ignorata" && "🚨"}
              {insight.type === "full" && "🔥"}
              {insight.type === "ritardo" && "⏱️"}
              {insight.type === "latenza" && "🍷"}
              {insight.type === "priorita" && "⚠️"}
              {insight.type === "upselling" && "🍰"}
              {insight.type === "percorso" && "🚶"}
              {insight.type === "stress" && "🔥"}
            </div>

            {/* TESTO */}
            <div
              style={{
                flex: 1,
                color: "#f5f5f7",
                fontSize: "0.88rem",
                fontWeight: "600",
                lineHeight: 1.35
              }}
            >
              {insight.text}
            </div>

          </div>
        );

      })}

    </div>

  </div>
)}

        {/* GRIGLIA TAVOLI */}
        {!localeTag && <div style={{ textAlign: 'center', padding: '2rem', color: '#f44336' }}><h3>Parametro locale mancante</h3></div>}
        {tavoliVisibili.length === 0 && localeTag ? (
          <div style={{ textAlign: 'center', padding: '2rem', color: '#666' }}><p>Caricamento tavoli per: <strong>{localeTag}</strong></p></div>
        ) : (
          <>
            {tavoliVisibili.filter(t => t.sala === "principale").length > 0 && (
              <div className="tavoli-section">
                <h4 className="tavoli-section-title">Tavoli Principali</h4>
                <div className="tavoli-grid">{tavoliVisibili.filter(t => t.sala === "principale").map(renderTavoloCard)}</div>
              </div>
            )}
            {[...new Set(tavoliVisibili.filter(t => t.sala !== "principale").map(t => t.sala))].sort().map(sala => (
              <div key={sala} className="tavoli-section">
                <h4 className="tavoli-section-title">Sala {sala}</h4>
                <div className="tavoli-grid">{tavoliVisibili.filter(t => t.sala === sala).map(renderTavoloCard)}</div>
              </div>
            ))}
          </>
        )}
      </div>

{alertAISelezionato && (
  <div
    className="modal-overlay"
    onClick={() => setAlertAISelezionato(null)}
  >
    <div
      className="app-modal"
      onClick={(e) => e.stopPropagation()}
      style={{
        maxWidth: "440px",
        width: "92%"
      }}
    >
      <h3 style={{ marginTop: 0 }}>
        🚨 Alert AI Cameriere
      </h3>

      <p style={{ color: "#aaa" }}>
        Tavolo {alertAISelezionato.numero}
      </p>

      <div style={{ display: "flex", flexDirection: "column", gap: "0.8rem" }}>
        {alertAISelezionato.alertAI.map((alert, index) => (
          <div
            key={index}
            style={{
              background: "rgba(255,59,48,0.12)",
              border: "1px solid rgba(255,59,48,0.35)",
              borderRadius: "14px",
              padding: "1rem",
              color: "#fff"
            }}
          >
            <strong>{alert.testo}</strong>
          </div>
        ))}
      </div>

<button
  onClick={() => {
    const tavolo = alertAISelezionato;
    setAlertAISelezionato(null);
    apriMenuTavolo(tavolo);
  }}
  style={{
    marginTop: "0.7rem",
    width: "100%",
    padding: "0.85rem",
    borderRadius: "12px",
    border: "none",
    background: "#0a84ff",
    color: "#fff",
    cursor: "pointer",
    fontWeight: "700"
  }}
>
  Apri tavolo
</button>

<button
  onClick={() => segnaAlertGestito(alertAISelezionato)}
  style={{
    marginTop: "0.7rem",
    width: "100%",
    padding: "0.85rem",
    borderRadius: "12px",
    border: "none",
    background: "rgba(52,199,89,0.18)",
    color: "#34c759",
    cursor: "pointer",
    fontWeight: "700"
  }}
>
  Alert gestito
</button>

      <button
        onClick={() => setAlertAISelezionato(null)}
        style={{
          marginTop: "1.2rem",
          width: "100%",
          padding: "0.85rem",
          borderRadius: "12px",
          border: "none",
          background: "#2c2c2e",
          color: "#fff",
          cursor: "pointer",
          fontWeight: "700"
        }}
      >
        Chiudi
      </button>
    </div>
  </div>
)}

      {/* MODALE PIATTI PRONTI */}
      {ordineProtiAperto && (
        <div className="modal-overlay" onClick={() => setOrdineProtiAperto(null)}>
          <div className="app-modal" onClick={(e) => e.stopPropagation()} style={{ maxHeight: '80vh', overflowY: 'auto' }}>
            <h3 style={{
              marginTop: 0,
              marginBottom: '1rem',
              color: 'white',
              fontWeight: '700',
              fontSize: '1.1rem',
              letterSpacing: '-0.3px'
            }}>
              🍽️ Tavolo {ordineProtiAperto.tavolo}
            </h3>
            <div style={{
              fontSize: '0.8rem',
              color: '#aaa',
              marginBottom: '1rem'
            }}>
              Piatti pronti
            </div>
            <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 1.5rem 0' }}>
              {(() => {
                const grouped = {};

                ordineProtiAperto.items.forEach((item) => {
                  const nome = item.nome || item.name || "";
                  const custom = (item.custom || "").trim();

                  const key = `${nome}__${custom}`;

                  if (!grouped[key]) {
                    grouped[key] = {
                      nome,
                      custom,
                      qty: 0
                    };
                  }

                  grouped[key].qty += 1;
                });

                return Object.values(grouped).map((item, i) => (
                  <li
                    key={i}
                    style={{
                      backgroundColor: '#1c1c1e',
                      padding: '0.9rem',
                      marginBottom: '0.5rem',
                      borderRadius: '10px',
                      border: '1px solid rgba(255,255,255,0.05)',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      gap: '0.75rem'
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                      <span
                        style={{
                          color: '#fff',
                          fontWeight: '600'
                        }}
                      >
                        {item.nome}
                      </span>

                      {item.custom && (
                        <span
                          style={{
                            marginTop: '4px',
                            fontSize: '0.78rem',
                            color: '#ff8a80',
                            fontWeight: '500',
                            wordBreak: 'break-word'
                          }}
                        >
                          📝 {item.custom}
                        </span>
                      )}
                    </div>

                    <span
                      style={{
                        background: '#0a84ff',
                        color: 'white',
                        borderRadius: '999px',
                        padding: '4px 10px',
                        fontSize: '0.75rem',
                        fontWeight: '700',
                        flexShrink: 0
                      }}
                    >
                      {item.qty}
                    </span>
                  </li>
                ));
              })()}
            </ul>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <button
                onClick={async () => {
                  const ordini = ordineProtiAperto.ordini || [];
                  const idsUnici = [...new Set(ordini.map(o => o.id))];
                  for (const id of idsUnici) {
                    if (id) {
                      await segnaOrdineServito(id);
                    }
                  }
                }}
                style={{ flex: 1, padding: '0.9rem', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '8px', fontSize: '1rem', fontWeight: '700', cursor: 'pointer' }}
              >
                ✔ Segna come Servito
              </button>
              <button onClick={() => setOrdineProtiAperto(null)} style={{ flex: 1, padding: '0.9rem', backgroundColor: '#e0e0e0', color: '#333', border: 'none', borderRadius: '8px', fontSize: '1rem', fontWeight: '600', cursor: 'pointer' }}>Chiudi</button>
            </div>
          </div>
        </div>
      )}


      {/* MODALE CATEGORIA NOTIFICA */}
      {dettagliOrdineAperto && (
        <div className="modal-overlay" onClick={() => setDettagliOrdineAperto(null)}>
          <div
            className="app-modal"
            onClick={(e) => e.stopPropagation()}
            style={{ maxHeight: '80vh', overflowY: 'auto' }}
          >
            <h3
              style={{
                marginTop: 0,
                marginBottom: '1rem',
                color: 'white',
                fontWeight: '700',
                fontSize: '1.1rem',
                letterSpacing: '-0.3px'
              }}
            >
              🥤 Tavolo {dettagliOrdineAperto.tavolo}
            </h3>

            <div
              style={{
                fontSize: '0.8rem',
                color: '#aaa',
                marginBottom: '1rem'
              }}
            >
              Da servire
            </div>

            <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 1.5rem 0' }}>
              {(() => {
                const grouped = {};

                (dettagliOrdineAperto.items || []).forEach((item) => {
                  const nome = item.name || item.nome || "";
                  const custom = (item.custom || "").trim();
                  if (!nome) return;

                  const key = `${nome}__${custom}`;

                  if (!grouped[key]) {
                    grouped[key] = {
                      nome,
                      custom,
                      qty: 0,
                      categoria:
                        item.categoria ||
                        item.category ||
                        (menu.find((p) => p.nome === nome || p.name === nome)?.categoria || "")
                    };
                  }

                  grouped[key].qty += 1;
                });

                return Object.values(grouped).map((item, idx) => (
                  <li
                    key={idx}
                    style={{
                      backgroundColor: '#1c1c1e',
                      padding: '0.9rem',
                      marginBottom: '0.5rem',
                      borderRadius: '10px',
                      border: '1px solid rgba(255,255,255,0.05)',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      gap: '0.75rem'
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                      <span style={{ color: '#fff', fontWeight: '600' }}>
                        {item.nome}
                      </span>

                      {item.custom && (
                        <span
                          style={{
                            marginTop: '4px',
                            fontSize: '0.78rem',
                            color: '#ff8a80',
                            fontWeight: '500',
                            wordBreak: 'break-word'
                          }}
                        >
                          📝 {item.custom}
                        </span>
                      )}
                    </div>

                    <span
                      style={{
                        background: '#34c759',
                        color: 'white',
                        borderRadius: '999px',
                        padding: '4px 10px',
                        fontSize: '0.75rem',
                        fontWeight: '700',
                        flexShrink: 0
                      }}
                    >
                      {item.qty}
                    </span>
                  </li>
                ));
              })()}
            </ul>

            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <button
                onClick={async () => {
                  try {
                    const ordini = dettagliOrdineAperto.ordini || [];
                    const idsUnici = [...new Set(ordini.map((o) => o.id).filter(Boolean))];

                    for (const id of idsUnici) {
                      const ordineRef = doc(db, "ordini", id);
                      const ordineSnap = await getDoc(ordineRef);
                      if (!ordineSnap.exists()) continue;

                      const dati = ordineSnap.data();

                      const items = (dati.items || []).map((item) => {
                        const nome = item.name || item.nome || "";
                        const piatto = menu.find((p) => p.nome === nome || p.name === nome);
                        const categoria = item.categoria || item.category || piatto?.categoria || "";

                        if (
                          categoriaNotifica.includes(categoria) &&
                          String(item.stato || "").toLowerCase() !== "servito"
                        ) {
                          return { ...item, stato: "servito" };
                        }

                        return item;
                      });

                      const STATI_PRIORITA = ["inviato", "in attesa", "in preparazione", "pronto", "servito"];

                      const statoMin = (lista) => {
                        for (const s of STATI_PRIORITA) {
                          if (lista.includes(s)) return s;
                        }
                        return lista[0] || "inviato";
                      };

                      const statiTutti = items.map(
  (i) => i.stato || dati.stato || "inviato"
);

const nuovoStatoGlobale = statoMin(statiTutti);

const itemStati = {};

items.forEach((item, index) => {
  itemStati[String(index)] =
    item.stato || dati.stato || "inviato";
});

const tuttoServito =
  items.length > 0 &&
  items.every(
    (item) =>
      String(item.stato || "").toLowerCase() === "servito"
  );

const updatePayload = {
  items,
  piatti: items,
  itemStati,
  stato: nuovoStatoGlobale,
  notificaServitaCategoria: true,
  notificaServitaCategoriaAt: serverTimestamp(),
  notificaServitaCategoriaDa: cameriereId || null
};

if (tuttoServito && !dati.servitoCompletamenteAt) {
  updatePayload.servitoCompletamenteAt = serverTimestamp();
}

await updateDoc(ordineRef, updatePayload);
                    }

                    setDettagliOrdineAperto(null);
                  } catch (e) {
                    console.error(e);
                  }
                }}
                style={{
                  flex: 1,
                  padding: '0.9rem',
                  backgroundColor: '#4CAF50',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  fontWeight: '700',
                  cursor: 'pointer'
                }}
              >
                ✔ Segna come Servito
              </button>

              <button
                onClick={() => setDettagliOrdineAperto(null)}
                style={{
                  flex: 1,
                  padding: '0.9rem',
                  backgroundColor: '#e0e0e0',
                  color: '#333',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  fontWeight: '600',
                  cursor: 'pointer'
                }}
              >
                Chiudi
              </button>
            </div>
          </div>
        </div>
      )}

      <audio ref={audioRef} src="/notification.mp3" preload="auto" />

      {/* Rimosso popup attivazione notifiche push */}

      {showSetupComplete && (
        <div className="modal-overlay" onClick={() => setShowSetupComplete(false)}>
          <div className="app-modal" onClick={(e) => e.stopPropagation()} style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>✅</div>
            <h3 style={{ margin: '0 0 0.8rem 0' }}>Configurazione completata!</h3>
            <p style={{ color: '#666', marginBottom: '1.5rem' }}>Il cameriere è stato configurato correttamente e riceverà le notifiche.</p>
            <button onClick={() => setShowSetupComplete(false)} style={{ padding: '0.7rem 1.5rem', borderRadius: '10px', border: 'none', backgroundColor: '#4CAF50', color: '#fff', fontWeight: '600', cursor: 'pointer' }}>Perfetto</button>
          </div>
        </div>
      )}
    </>
  );
}

export default DashboardCameriere;